import { useState, useEffect, useRef } from "react";
import { dbService } from "./firebase/config";
import logoImg from './logo.png';   // adjust relative path if needed

// ─── Constants ────────────────────────────────────────────────────────────────
const DOMAINS = ["IT","AIML","Mechatronics","Electronics","Civil","Mechanical","Chemical","Biomedical","Other"];
const STAFF_LIST = ["Rahul Sharma","Priya Patel","Anjali Singh","Vikram Desai","Neha Joshi"];
const STATUSES = ["Inquiry","In Progress","Review","Completed","On Hold"];
const CONTENT_TYPES = [
  {id:"abstract",label:"Abstract",icon:"📄",color:"#4F46E5",bg:"#EEF2FF"},
  {id:"intro",label:"Introduction",icon:"📖",color:"#0891B2",bg:"#ECFEFF"},
  {id:"block_diagram",label:"Block Diagram",icon:"🔷",color:"#7C3AED",bg:"#F5F3FF"},
  {id:"circuit",label:"Circuit Diagram",icon:"⚡",color:"#D97706",bg:"#FFFBEB"},
  {id:"flowchart",label:"Flowchart",icon:"🔄",color:"#059669",bg:"#ECFDF5"},
  {id:"code",label:"Code Snippet",icon:"💻",color:"#1D4ED8",bg:"#EFF6FF"},
  {id:"synopsis",label:"Synopsis",icon:"📋",color:"#BE185D",bg:"#FDF2F8"},
  {id:"ppt",label:"PPT Content",icon:"🖥️",color:"#EA580C",bg:"#FFF7ED"},
  {id:"reference",label:"References",icon:"📚",color:"#64748B",bg:"#F8FAFC"},
  {id:"result",label:"Result/Output",icon:"🏆",color:"#16A34A",bg:"#F0FDF4"},
];

const COMPANY = {
  name: "Engineering Project Consultancy",
  tagline: "Karolina Enterprises",
  address: "Plot No. 77, MG nagar hudkeshwar road, Nagpur – 440034, Maharashtra",
  phone: "+91 98344 55108",
  email: "info@tkarolinaenterprises.in",
  gst: "27ATOPC9436D1ZK",
  website: "https://engneeringpc.web.app",
  logoEmoji: logoImg,
};

// const SEED_PROJECTS = [
//   {
//     id:"p1",studentName:"Aarav Mehta",email:"aarav@gmail.com",phone:"9876543210",
//     college:"VJTI Mumbai",domain:"AIML",title:"Smart Traffic Management using YOLO",
//     staff:"Rahul Sharma",totalBudget:15000,advancePaid:7500,paymentMode:"Online",
//     status:"In Progress",notes:"Deep learning based real-time traffic analysis",createdAt:"2025-01-10",
//     portalPin:"4421",
//     contacts:[{id:"c1",name:"Aarav Mehta",email:"aarav@gmail.com",phone:"9876543210",role:"Student",addedAt:"2025-01-10"}],
//     payments:[{id:"pay1",amount:7500,mode:"Online",date:"2025-01-10",note:"Advance payment",receiptNo:"RCP-2025-001"}],
//     contentBlocks:[
//       {id:"cb1",type:"abstract",title:"Project Abstract",body:"This project proposes an intelligent traffic management system leveraging YOLO v8 for real-time vehicle detection. The system identifies congestion patterns and dynamically adjusts signal timings.",sentAt:"2025-01-12",sentBy:"Rahul Sharma",readAt:"2025-01-12"},
//       {id:"cb2",type:"block_diagram",title:"System Block Diagram",body:"Input Layer → Camera Feed (USB/IP Cam)\nProcessing Layer → Raspberry Pi 4 + YOLO v8 Model\nDecision Layer → Signal Controller (Arduino)\nOutput Layer → Traffic Signal + Dashboard Display",sentAt:"2025-01-14",sentBy:"Rahul Sharma",readAt:null},
//     ]
//   },
//   {
//     id:"p2",studentName:"Sneha Kulkarni",email:"sneha@gmail.com",phone:"9012345678",
//     college:"MIT Pune",domain:"IT",title:"Hospital Management System",
//     staff:"Priya Patel",totalBudget:12000,advancePaid:12000,paymentMode:"Cash",
//     status:"Completed",notes:"PHP + MySQL full stack",createdAt:"2025-01-05",
//     portalPin:"7832",
//     contacts:[{id:"c2",name:"Sneha Kulkarni",email:"sneha@gmail.com",phone:"9012345678",role:"Student",addedAt:"2025-01-05"}],
//     payments:[
//       {id:"pay2",amount:7000,mode:"Cash",date:"2025-01-05",note:"Initial advance",receiptNo:"RCP-2025-002"},
//       {id:"pay3",amount:5000,mode:"Cash",date:"2025-01-20",note:"Final payment",receiptNo:"RCP-2025-003"},
//     ],
//     contentBlocks:[
//       {id:"cb3",type:"abstract",title:"Project Abstract",body:"A web-based hospital management solution enabling patient registration, appointment scheduling, billing, and report generation. Built on PHP 8.1 with MySQL 8.0 and Bootstrap 5 frontend.",sentAt:"2025-01-06",sentBy:"Priya Patel",readAt:"2025-01-07"},
//     ]
//   },
//   {
//     id:"p3",studentName:"Karan Joshi",email:"karan@gmail.com",phone:"8765432109",
//     college:"DKTE Kolhapur",domain:"Mechatronics",title:"Robotic Arm with IoT Control",
//     staff:"Vikram Desai",totalBudget:22000,advancePaid:8000,paymentMode:"Online",
//     status:"In Progress",notes:"Arduino + Raspberry Pi",createdAt:"2025-01-15",
//     portalPin:"3309",
//     contacts:[{id:"c3",name:"Karan Joshi",email:"karan@gmail.com",phone:"8765432109",role:"Student",addedAt:"2025-01-15"}],
//     payments:[{id:"pay4",amount:8000,mode:"Online",date:"2025-01-15",note:"Advance payment",receiptNo:"RCP-2025-004"}],
//     contentBlocks:[]
//   }
// ];

// ─── Helpers ─────────────────────────────────────────────────────────────────
// const genId = () => `id_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;
// const genReceiptNo = () => `RCP-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
// const fmtDate = d => d ? new Date(d).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"}) : "";
// const fmtDateTime = d => d ? new Date(d).toLocaleString("en-IN",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}) : "";
// const now = () => new Date().toISOString();
// const initials = name => name.split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();
// const getStorage = (k,def) => { try{ return JSON.parse(localStorage.getItem(k)) ?? def; }catch{ return def; } };
// const setStorage = (k,v) => { try{ localStorage.setItem(k,JSON.stringify(v)); }catch{} };

// ─── Helpers ─────────────────────────────────────────────────────────────────
const genId = () => {
  // Generate a 6-digit number (100000 to 999999)
  return String(Math.floor(100000 + Math.random() * 900000));
};
const genReceiptNo = () => `RCP-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
const fmtDate = d => d ? new Date(d).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"}) : "";
const fmtDateTime = d => d ? new Date(d).toLocaleString("en-IN",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}) : "";
const now = () => new Date().toISOString();
const initials = name => name.split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();

const C = {
  navy:"#0B1220", navyLight:"#141E33", navyBorder:"rgba(255,255,255,0.08)",
  indigo:"#4F46E5", indigoLight:"#818CF8", indigoBg:"#EEF2FF",
  mint:"#10B981", mintBg:"#ECFDF5",
  amber:"#F59E0B", amberBg:"#FFFBEB",
  rose:"#F43F5E", roseBg:"#FFF1F2",
  slate:"#64748B", slateBg:"#F8FAFC",
  card:"var(--color-background-primary)", border:"var(--color-border-tertiary)",
  text:"var(--color-text-primary)", muted:"var(--color-text-secondary)",
  bg:"var(--color-background-tertiary)", surface:"var(--color-background-secondary)",
};
const statusMeta = {
  "Inquiry":{c:"#1D4ED8",bg:"#EFF6FF",dot:"#3B82F6"},
  "In Progress":{c:"#92400E",bg:"#FFFBEB",dot:"#F59E0B"},
  "Review":{c:"#5B21B6",bg:"#F5F3FF",dot:"#7C3AED"},
  "Completed":{c:"#065F46",bg:"#ECFDF5",dot:"#10B981"},
  "On Hold":{c:"#9F1239",bg:"#FFF1F2",dot:"#F43F5E"},
};

// ─── UI Components ────────────────────────────────────────────────────────────
const Badge = ({children,status}) => {
  const m = statusMeta[status]||{c:C.slate,bg:C.slateBg,dot:C.slate};
  return <span style={{display:"inline-flex",alignItems:"center",gap:5,background:m.bg,color:m.c,
    fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:99,letterSpacing:"0.03em"}}>
    <span style={{width:6,height:6,borderRadius:"50%",background:m.dot,flexShrink:0}}/>
    {children}
  </span>;
};
const Avatar = ({name,size=36,bg="#EEF2FF",color="#4F46E5",style:s={}}) => (
  <div style={{width:size,height:size,borderRadius:"50%",background:bg,display:"flex",alignItems:"center",
    justifyContent:"center",fontWeight:700,fontSize:size*0.33,color,flexShrink:0,...s}}>
    {initials(name)}
  </div>
);
const Card = ({children,style={}}) => (
  <div style={{background:C.card,borderRadius:16,border:`1px solid ${C.border}`,padding:"20px 22px",...style}}>{children}</div>
);
const Toast = ({msg,type="success",onDone}) => {
  useEffect(()=>{const t=setTimeout(onDone,2800);return()=>clearTimeout(t);},[]);
  return <div style={{position:"fixed",bottom:24,right:24,zIndex:9999,
    background:type==="success"?"#064E3B":"#7F1D1D",color:"#fff",
    padding:"12px 20px",borderRadius:12,fontSize:14,fontWeight:500,
    boxShadow:"0 8px 32px rgba(0,0,0,0.25)",display:"flex",alignItems:"center",gap:10}}>
    <span>{type==="success"?"✓":"✕"}</span>{msg}
  </div>;
};

// ─── NUMBER TO WORDS ──────────────────────────────────────────────────────────
function numberToWords(num) {
  const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const tens = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  if(num === 0) return "Zero";
  if(num < 20) return ones[num];
  if(num < 100) return tens[Math.floor(num/10)] + (num%10 ? " "+ones[num%10] : "");
  if(num < 1000) return ones[Math.floor(num/100)] + " Hundred" + (num%100 ? " "+numberToWords(num%100) : "");
  if(num < 100000) return numberToWords(Math.floor(num/1000)) + " Thousand" + (num%1000 ? " "+numberToWords(num%1000) : "");
  if(num < 10000000) return numberToWords(Math.floor(num/100000)) + " Lakh" + (num%100000 ? " "+numberToWords(num%100000) : "");
  return numberToWords(Math.floor(num/10000000)) + " Crore" + (num%10000000 ? " "+numberToWords(num%10000000) : "");
}

// ─── RECEIPT MODAL (proper PDF via iframe print) ──────────────────────────────
function ReceiptModal({project, payment, onClose}) {
  const iframeRef = useRef();

  // ── safe defaults for ALL used fields ──
  const safePayment = payment || {};
  const safeProject = project || {};

  // Numbers / strings that may be undefined
  const amount = safePayment.amount ?? 0;
  const date = safePayment.date ?? null;
  const receiptNo = safePayment.receiptNo ?? "N/A";
  const mode = safePayment.mode ?? "—";
  const note = safePayment.note ?? "";

  const totalBudget = safeProject.totalBudget ?? 0;
  const advancePaid = safeProject.advancePaid ?? 0;
  const studentName = safeProject.studentName ?? "Unknown";
  const college = safeProject.college ?? "—";
  const email = safeProject.email ?? "—";
  const phone = safeProject.phone ?? "—";
  const domain = safeProject.domain ?? "—";
  const staff = safeProject.staff ?? "—";
  const title = safeProject.title ?? "No title";
  const status = safeProject.status ?? "Inquiry";
  const createdAt = safeProject.createdAt ?? null;
  const projectId = safeProject.id ?? "N/A";

 const getReceiptHTML = () => `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Receipt ${receiptNo}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  *{margin:0;padding:0;box-sizing:border-box;}

  @page { size: A4; margin: 0; }

  html,body{font-family:'Inter',Arial,sans-serif;background:#E7E9EE;color:#111;-webkit-print-color-adjust:exact;print-color-adjust:exact;}

  /* A4 = 210mm x 297mm — everything below is sized to fit on this one sheet */
  .page{width:210mm;min-height:297mm;margin:0 auto;background:#fff;display:flex;flex-direction:column;}

  .header{background:#0B1220;padding:20px 32px 16px;position:relative;overflow:hidden;flex-shrink:0;}
  .header-accent{position:absolute;right:-50px;top:-50px;width:180px;height:180px;border-radius:50%;background:rgba(79,70,229,0.18);}
  .header-accent2{position:absolute;left:-30px;bottom:-30px;width:120px;height:120px;border-radius:50%;background:rgba(16,185,129,0.1);}
  .logo-row{display:flex;align-items:flex-start;gap:12px;margin-bottom:14px;position:relative;z-index:1;}
  .logo-box{width:44px;height:44px;min-width:44px;border-radius:12px;background:linear-gradient(135deg,#4F46E5,#818CF8);display:flex;align-items:center;justify-content:center;font-size:21px;}
  .co-name{color:#fff;font-size:18px;font-weight:800;letter-spacing:-0.02em;line-height:1.2;}
  .co-tag{color:rgba(255,255,255,0.55);font-size:10px;margin-top:2px;}
  .co-addr{color:rgba(255,255,255,0.4);font-size:9px;line-height:1.7;margin-top:5px;}
  .receipt-band{position:relative;z-index:1;display:flex;justify-content:space-between;align-items:flex-end;padding-top:12px;border-top:1px solid rgba(255,255,255,0.1);}
  .receipt-word{font-size:24px;font-weight:900;color:#818CF8;letter-spacing:0.06em;}
  .receipt-meta{text-align:right;font-size:10px;color:rgba(255,255,255,0.5);line-height:1.9;}
  .receipt-meta strong{color:rgba(255,255,255,0.85);}

  .body{padding:20px 32px;flex:1;}
  .sec-label{font-size:9px;font-weight:700;color:#4F46E5;text-transform:uppercase;letter-spacing:0.12em;margin-bottom:8px;}
  .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 20px;margin-bottom:4px;}
  .info-item .k{font-size:8.5px;color:#94A3B8;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:2px;}
  .info-item .v{font-size:12px;font-weight:600;color:#111;}
  .divider{height:1px;background:#F1F5F9;margin:14px 0;}

  .amount-box{background:linear-gradient(135deg,#EEF2FF 0%,#F5F3FF 100%);border-radius:14px;padding:16px 20px;display:flex;justify-content:space-between;align-items:center;margin:14px 0;border:1px solid #C7D2FE;}
  .amount-label{font-size:9.5px;color:#4F46E5;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:5px;}
  .amount-value{font-size:28px;font-weight:900;color:#3730A3;letter-spacing:-0.02em;}
  .amount-words{font-size:10.5px;color:#6366F1;margin-top:3px;font-style:italic;}
  .stamp{width:60px;height:60px;border-radius:50%;border:3px solid #10B981;display:flex;align-items:center;justify-content:center;flex-direction:column;transform:rotate(-12deg);color:#10B981;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:0.04em;line-height:1.3;}
  .stamp-check{font-size:16px;line-height:1;margin-bottom:2px;}

  .summary-table{width:100%;border-collapse:collapse;margin:2px 0;}
  .summary-table tr td{padding:5px 0;border-bottom:1px solid #F1F5F9;font-size:11px;}
  .summary-table tr td:first-child{color:#64748B;}
  .summary-table tr td:last-child{text-align:right;font-weight:600;color:#111;}
  .summary-table tr.total td{border-bottom:none;border-top:2px solid #E2E8F0;padding-top:9px;font-size:13px;font-weight:700;}
  .summary-table tr.total td:last-child{color:#059669;}
  .summary-table tr.due td:last-child{color:#D97706;}

  .refund-box{background:#FEF2F2;border:1.5px solid #FECACA;border-radius:12px;padding:12px 16px;margin:12px 0;}
  .refund-box .rb-title{color:#991B1B;font-size:9.5px;font-weight:800;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:5px;}
  .refund-box p{color:#7F1D1D;font-size:10px;line-height:1.6;}

  .status-badge{display:inline-flex;align-items:center;gap:6px;padding:5px 14px;border-radius:99px;font-size:11px;font-weight:700;}
  .status-paid{background:#ECFDF5;color:#065F46;}
  .status-partial{background:#FFFBEB;color:#92400E;}

  .sig-row{display:flex;justify-content:space-between;align-items:flex-end;margin-top:16px;}
  .sig-line{width:110px;border-top:2px solid #CBD5E1;padding-top:5px;text-align:center;font-size:9.5px;color:#94A3B8;}
  .sys-note{font-size:9.5px;color:#94A3B8;line-height:1.7;}

  .footer{background:#F8FAFC;padding:12px 32px;border-top:1px solid #E2E8F0;text-align:center;flex-shrink:0;}
  .footer p{font-size:9.5px;color:#94A3B8;line-height:1.8;}
  .footer .thanks{font-size:11px;color:#64748B;font-weight:700;margin-top:3px;}

  @media print{
    *{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;}
    body{background:#fff;}
    .page{width:auto;min-height:auto;}
    .header{background:#0B1220!important;}
    .amount-box{background:linear-gradient(135deg,#EEF2FF,#F5F3FF)!important;}
    .refund-box{background:#FEF2F2!important;}
    .footer{background:#F8FAFC!important;}
  }
</style>
</head>
<body>
<div class="page">
  <div class="header">
    <div class="header-accent"></div>
    <div class="header-accent2"></div>
    <div class="logo-row">
      <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
      <div>
        <div class="co-name">${COMPANY.name}</div>
        <div class="co-tag">${COMPANY.tagline}</div>
        <div class="co-addr">
          ${COMPANY.address}<br/>
          ${COMPANY.phone} &nbsp;·&nbsp; ${COMPANY.email}<br/>
          GST: ${COMPANY.gst} &nbsp;·&nbsp; ${COMPANY.website}
        </div>
      </div>
    </div>
    <div class="receipt-band">
      <div class="receipt-word">RECEIPT</div>
      <div class="receipt-meta">
        <div>Receipt No: <strong>${receiptNo}</strong></div>
        <div>Date: <strong>${fmtDate(date)}</strong></div>
        <div>Project ID: <strong>${projectId.toUpperCase()}</strong></div>
      </div>
    </div>
  </div>

  <div class="body">
    <div class="sec-label">Bill To</div>
    <div class="info-grid">
      <div class="info-item"><div class="k">Student Name</div><div class="v">${studentName}</div></div>
      <div class="info-item"><div class="k">College</div><div class="v">${college}</div></div>
      <div class="info-item"><div class="k">Email</div><div class="v">${email}</div></div>
      <div class="info-item"><div class="k">Phone</div><div class="v">${phone}</div></div>
    </div>

    <div class="divider"></div>
    <div class="sec-label">Project Details</div>
    <div class="info-grid">
      <div class="info-item"><div class="k">Domain</div><div class="v">${domain}</div></div>
      <div class="info-item"><div class="k">Assigned Staff</div><div class="v">${staff}</div></div>
      <div class="info-item" style="grid-column:1/-1"><div class="k">Project Title</div><div class="v">${title}</div></div>
      <div class="info-item"><div class="k">Status</div><div class="v">${status}</div></div>
      <div class="info-item"><div class="k">Registered On</div><div class="v">${fmtDate(createdAt)}</div></div>
    </div>

    <div class="amount-box">
      <div>
        <div class="amount-label">Amount Paid</div>
        <div class="amount-value">₹${amount.toLocaleString("en-IN")}</div>
        <div class="amount-words">${numberToWords(amount)} Rupees Only</div>
      </div>
      <div class="stamp">
        <div class="stamp-check">✓</div>
        <div>Paid</div>
      </div>
    </div>

    <div class="sec-label">Payment Summary</div>
    <table class="summary-table">
      <tr><td>Payment Mode</td><td>${mode}</td></tr>
      <tr><td>Narration / Remarks</td><td>${note || "—"}</td></tr>
      <tr><td>Total Project Budget</td><td>₹${totalBudget.toLocaleString("en-IN")}</td></tr>
      <tr><td>Total Amount Paid Till Date</td><td>₹${advancePaid.toLocaleString("en-IN")}</td></tr>
      <tr class="${advancePaid >= totalBudget ? 'total' : 'total due'}">
        <td>${advancePaid >= totalBudget ? "✅ Fully Paid" : "⏳ Balance Due"}</td>
        <td>${advancePaid >= totalBudget ? "NIL" : "₹" + (totalBudget - advancePaid).toLocaleString("en-IN")}</td>
      </tr>
    </table>

    <div style="text-align:center;margin:12px 0;">
      <span class="status-badge ${advancePaid >= totalBudget ? 'status-paid' : 'status-partial'}">
        ${advancePaid >= totalBudget ? "✅ PAYMENT COMPLETE" : "⏳ PAYMENT PARTIALLY RECEIVED"}
      </span>
    </div>

    <div class="refund-box">
      <div class="rb-title">⚠️ Important Notice — No Refund Policy</div>
      <p>Once payment is made, it is <strong>strictly non-refundable under any circumstances</strong>. By making this payment, you acknowledge and agree that ${COMPANY.name} will commence work on your project immediately upon receipt of payment. No cancellations, transfers, or refunds will be entertained once payment is processed. For queries, contact us before payment at <strong>${COMPANY.email}</strong>.</p>
    </div>

    <div class="sig-row">
      <div class="sys-note">
        <div>Computer-generated receipt. No wet signature required.</div>
        <div>Generated by ${COMPANY.name} ERP System</div>
      </div>
      <div class="sig-line">Authorised Signatory</div>
    </div>
  </div>

  <div class="footer">
    <p>${COMPANY.name} &nbsp;·&nbsp; ${COMPANY.address}</p>
    <p>${COMPANY.phone} &nbsp;·&nbsp; ${COMPANY.email} &nbsp;·&nbsp; ${COMPANY.website}</p>
    <p class="thanks">Thank you for choosing ${COMPANY.name}!</p>
  </div>
</div>
</body>
</html>`;

  const handlePrint = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const iframeWin = iframe.contentWindow || iframe.contentDocument?.defaultView;
    if (iframeWin) {
      iframeWin.focus();
      iframeWin.print();
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(getReceiptHTML());
      doc.close();
    }
  }, []);

  // If payment is completely missing, show an error placeholder (optional)
  if (!payment) {
    return (
      <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{background:"#fff",borderRadius:20,padding:40,textAlign:"center"}}>
          <p>Receipt data not available.</p>
          <button onClick={onClose} style={primaryBtn("#4F46E5","#fff")}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(6px)"}}>
      <iframe ref={iframeRef} title="receipt-print" style={{position:"absolute",left:"-9999px",top:"-9999px",width:"800px",height:"1100px",border:"none",opacity:0,pointerEvents:"none"}}/>

      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:24,maxWidth:700,width:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 32px 80px rgba(0,0,0,0.5)"}}>
        {/* Live preview */}
        <div style={{borderRadius:"24px 24px 0 0",overflow:"hidden"}}>
          {/* Header */}
          <div style={{background:"#0B1220",padding:"28px 36px 22px",position:"relative",overflow:"hidden"}}>
            <div style={{position:"absolute",right:-50,top:-50,width:180,height:180,borderRadius:"50%",background:"rgba(79,70,229,0.18)"}}/>
            <div style={{position:"absolute",left:-30,bottom:-30,width:120,height:120,borderRadius:"50%",background:"rgba(16,185,129,0.1)"}}/>
            <div style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:18,position:"relative",zIndex:1}}>
             <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
              <div>
                <div style={{color:"#fff",fontSize:20,fontWeight:800}}>{COMPANY.name}</div>
                <div style={{color:"rgba(255,255,255,0.5)",fontSize:11}}>{COMPANY.tagline}</div>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,lineHeight:1.8}}>{COMPANY.address} · GST: {COMPANY.gst}</div>
              </div>
            </div>
            <div style={{position:"relative",zIndex:1,display:"flex",justifyContent:"space-between",alignItems:"flex-end",paddingTop:16,borderTop:"1px solid rgba(255,255,255,0.1)"}}>
              <div style={{fontSize:28,fontWeight:900,color:"#818CF8",letterSpacing:"0.06em"}}>RECEIPT</div>
              <div style={{textAlign:"right",fontSize:11,color:"rgba(255,255,255,0.5)",lineHeight:2}}>
                <div>Receipt No: <strong style={{color:"rgba(255,255,255,0.85)"}}>{receiptNo}</strong></div>
                <div>Date: <strong style={{color:"rgba(255,255,255,0.85)"}}>{fmtDate(date)}</strong></div>
                <div>Project ID: <strong style={{color:"rgba(255,255,255,0.85)"}}>{projectId.toUpperCase()}</strong></div>
              </div>
            </div>
          </div>

          <div style={{padding:"24px 36px",background:"#fff"}}>
            {/* Bill To */}
            <div style={{fontSize:9,fontWeight:700,color:"#4F46E5",textTransform:"uppercase",letterSpacing:"0.12em",marginBottom:10}}>Bill To</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px 20px",marginBottom:6}}>
              {[["Student Name",studentName],["College",college],["Email",email],["Phone",phone]].map(([k,v])=>(
                <div key={k}><div style={{fontSize:9,color:"#94A3B8",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{k}</div><div style={{fontSize:13,fontWeight:600,color:"#111"}}>{v}</div></div>
              ))}
            </div>
            <div style={{height:1,background:"#F1F5F9",margin:"18px 0"}}/>
            <div style={{fontSize:9,fontWeight:700,color:"#4F46E5",textTransform:"uppercase",letterSpacing:"0.12em",marginBottom:10}}>Project Details</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px 20px"}}>
              <div><div style={{fontSize:9,color:"#94A3B8",fontWeight:600}}>Domain</div><div style={{fontSize:13,fontWeight:600}}>{domain}</div></div>
              <div><div style={{fontSize:9,color:"#94A3B8",fontWeight:600}}>Assigned Staff</div><div style={{fontSize:13,fontWeight:600}}>{staff}</div></div>
              <div style={{gridColumn:"1/-1"}}><div style={{fontSize:9,color:"#94A3B8",fontWeight:600}}>Project Title</div><div style={{fontSize:13,fontWeight:600}}>{title}</div></div>
            </div>

            {/* Amount Box */}
            <div style={{background:"linear-gradient(135deg,#EEF2FF,#F5F3FF)",border:"1px solid #C7D2FE",borderRadius:16,padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",margin:"18px 0"}}>
              <div>
                <div style={{fontSize:10,color:"#4F46E5",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6}}>Amount Paid</div>
                <div style={{fontSize:34,fontWeight:900,color:"#3730A3"}}>₹{amount.toLocaleString("en-IN")}</div>
                <div style={{fontSize:11,color:"#6366F1",marginTop:4,fontStyle:"italic"}}>{numberToWords(amount)} Rupees Only</div>
              </div>
              <div style={{width:72,height:72,borderRadius:"50%",border:"3px solid #10B981",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",transform:"rotate(-12deg)",color:"#10B981",fontSize:10,fontWeight:800}}>
                <div style={{fontSize:18,lineHeight:1}}>✓</div>
                <div>Paid</div>
              </div>
            </div>

            {/* Payment Summary */}
            <div style={{fontSize:9,fontWeight:700,color:"#4F46E5",textTransform:"uppercase",letterSpacing:"0.12em",marginBottom:10}}>Payment Summary</div>
            {[["Payment Mode",mode],["Narration / Remarks",note||"—"],["Total Project Budget",`₹${totalBudget.toLocaleString("en-IN")}`],["Total Amount Paid Till Date",`₹${advancePaid.toLocaleString("en-IN")}`]].map(([k,v])=>(
              <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid #F1F5F9",fontSize:12}}>
                <span style={{color:"#64748B"}}>{k}</span><span style={{fontWeight:600}}>{v}</span>
              </div>
            ))}
            <div style={{display:"flex",justifyContent:"space-between",padding:"12px 0",fontSize:14,fontWeight:700,borderTop:"2px solid #E2E8F0"}}>
              <span>{advancePaid>=totalBudget?"✅ Fully Paid":"⏳ Balance Due"}</span>
              <span style={{color:advancePaid>=totalBudget?"#059669":"#D97706"}}>
                {advancePaid>=totalBudget?"NIL":`₹${(totalBudget-advancePaid).toLocaleString("en-IN")}`}
              </span>
            </div>

            <div style={{textAlign:"center",margin:"12px 0"}}>
              <span style={{display:"inline-flex",alignItems:"center",gap:6,padding:"6px 18px",borderRadius:99,fontSize:12,fontWeight:700,background:advancePaid>=totalBudget?"#ECFDF5":"#FFFBEB",color:advancePaid>=totalBudget?"#065F46":"#92400E"}}>
                {advancePaid>=totalBudget?"✅ PAYMENT COMPLETE":"⏳ PAYMENT PARTIALLY RECEIVED"}
              </span>
            </div>

            <div style={{background:"#FEF2F2",border:"1.5px solid #FECACA",borderRadius:12,padding:"14px 18px",marginTop:14}}>
              <div style={{color:"#991B1B",fontSize:10,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6}}>⚠️ Important Notice — No Refund Policy</div>
              <div style={{color:"#7F1D1D",fontSize:11,lineHeight:1.7}}>Once payment is made, it is <strong>strictly non-refundable under any circumstances</strong>.</div>
            </div>

            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginTop:22}}>
              <div style={{fontSize:10,color:"#94A3B8",lineHeight:1.8}}>
                <div>Computer-generated receipt. No wet signature required.</div>
                <div>Generated by {COMPANY.name} ERP System</div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{width:120,borderTop:"2px solid #CBD5E1",paddingTop:6,fontSize:10,color:"#94A3B8"}}>Authorised Signatory</div>
              </div>
            </div>
          </div>

          <div style={{background:"#F8FAFC",padding:"14px 36px",borderTop:"1px solid #E2E8F0",textAlign:"center"}}>
            <div style={{fontSize:10,color:"#94A3B8",lineHeight:1.9}}>{COMPANY.name} · {COMPANY.address}</div>
            <div style={{fontSize:11,color:"#64748B",fontWeight:700,marginTop:4}}>Thank you for choosing {COMPANY.name}!</div>
          </div>
        </div>

        <div style={{padding:"16px 24px",display:"flex",gap:10,justifyContent:"flex-end",background:"#fff",borderRadius:"0 0 24px 24px",borderTop:"1px solid #E2E8F0"}}>
          <button onClick={onClose} style={ghostBtn()}>Close</button>
          <button onClick={handlePrint} style={primaryBtn("#4F46E5","#fff",{fontSize:14,fontWeight:700,padding:"10px 24px"})}>
            🖨️ Print / Save as PDF
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main App ─────────────────────────────────────────────────────────────────
export default function App() {
  // const [projects, setProjects] = useState(()=>getStorage("tph_projects2", SEED_PROJECTS));
  // const [view, setView] = useState("home");
  // const [activeProject, setActiveProject] = useState(null);
  // const [studentProject, setStudentProject] = useState(null);
  // const [staffTab, setStaffTab] = useState("overview");
  // const [studentTab, setStudentTab] = useState("timeline");
  // const [toast, setToast] = useState(null);
  // const [staffPwd, setStaffPwd] = useState("");
  // const [staffErr, setStaffErr] = useState("");
  // const [staffLoading, setStaffLoading] = useState(false);
  // const [studentPin, setStudentPin] = useState("");
  // const [studentErr, setStudentErr] = useState("");
  // const [studentLoading, setStudentLoading] = useState(false);
  // const [projectIdInput, setProjectIdInput] = useState("");

    const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("home");
  const [activeProject, setActiveProject] = useState(null);
  const [studentProject, setStudentProject] = useState(null);
  const [staffTab, setStaffTab] = useState("overview");
  const [studentTab, setStudentTab] = useState("timeline");
  const [toast, setToast] = useState(null);
  const [staffPwd, setStaffPwd] = useState("");
  const [staffErr, setStaffErr] = useState("");
  const [staffLoading, setStaffLoading] = useState(false);
  const [studentPin, setStudentPin] = useState("");
  const [studentErr, setStudentErr] = useState("");
  const [studentLoading, setStudentLoading] = useState(false);
  const [projectIdInput, setProjectIdInput] = useState("");
  const [staffPin, setStaffPin] = useState("");

    // Load projects from Firebase RTDB on mount
 // Instead of this:
useEffect(() => {
  const unsubscribe = dbService.subscribeProjects((fetchedProjects) => {
    setProjects(fetchedProjects);
    setLoading(false);
  });
  return () => unsubscribe();
}, []);

// Use this with a comparison to prevent unnecessary updates:
useEffect(() => {
  const unsubscribe = dbService.subscribeProjects((fetchedProjects) => {
    setLoading(false);
    // Only update if projects actually changed
    setProjects(prevProjects => {
      // Simple comparison - you might want a deeper comparison
      if (JSON.stringify(prevProjects) === JSON.stringify(fetchedProjects)) {
        return prevProjects;
      }
      return fetchedProjects;
    });
  });
  return () => unsubscribe();
}, []);

  // useEffect(()=>{ setStorage("tph_projects2",projects); },[projects]);
  // const showToast = (msg,type="success") => setToast({msg,type});
  // const updateProject = (updated) => {
  //   setProjects(p=>p.map(x=>x.id===updated.id?updated:x));
  //   if(activeProject?.id===updated.id) setActiveProject(updated);
  //   if(studentProject?.id===updated.id) setStudentProject(updated);
  // };
    const showToast = (msg, type = "success") => setToast({ msg, type });


  //const addProject = (proj) => setProjects(p=>[proj,...p]);

  const updateProject = async (updated) => {
  try {
    // Remove the id from the data being updated
    const { id, ...updateData } = updated;
    await dbService.updateProject(updated.id, updateData);
    // Don't manually update state here - let the subscription handle it
    // The subscription will automatically update the projects state
    showToast("Project updated successfully!");
  } catch (error) {
    console.error("Error updating project:", error);
    showToast("Error updating project", "error");
  }
};

// Add this utility function at the top of your file
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Then in your useEffect:
useEffect(() => {
  const handleProjectsUpdate = debounce((fetchedProjects) => {
    setProjects(fetchedProjects);
    setLoading(false);
  }, 300);

  const unsubscribe = dbService.subscribeProjects(handleProjectsUpdate);
  return () => unsubscribe();
}, []);

// Add this at the top of your App component
const isMounted = useRef(true);

useEffect(() => {
  isMounted.current = true;
  const unsubscribe = dbService.subscribeProjects((fetchedProjects) => {
    if (isMounted.current) {
      setProjects(fetchedProjects);
      setLoading(false);
    }
  });
  return () => {
    isMounted.current = false;
    unsubscribe();
  };
}, []);

const addProject = async (proj) => {
  try {
    const cleanProject = JSON.parse(JSON.stringify(proj));
    // Make sure the ID is set
    if (!cleanProject.id) {
      cleanProject.id = genId();
    }
    const newProject = await dbService.addProjectWithId(cleanProject.id, cleanProject);
    showToast("Project registered successfully!");
    // Return the project with the ID
    return newProject;
  } catch (error) {
    console.error("Error adding project:", error);
    showToast("Error registering project", "error");
    throw error;
  }
};
  // Loading state
  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0B1220"
      }}>
        <div style={{ textAlign: "center", color: "#fff" }}>
          <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>Loading...</div>
        </div>
      </div>
    );
  }

  if(view==="home") return <HomeView setView={setView} projects={projects} addProject={addProject} showToast={showToast} toast={toast} setToast={setToast}/>;

 if(view==="staff_login") return (
  <AuthScreen
    icon="🔐"
    iconBg="linear-gradient(135deg,#4F46E5,#818CF8)"
    title="Staff Login"
    subtitle="Access the project management dashboard"
    accentColor="#4F46E5"
    accentLight="#EEF2FF"
    onBack={()=>setView("home")}
  >
    <div style={{marginBottom:20}}>
      <label style={authLabel}>Password</label>
      <div style={{position:"relative"}}>
        <input type="password" value={staffPwd} onChange={e=>setStaffPwd(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&handleStaffLogin()}
          placeholder="Enter staff password"
          style={authInput(staffErr)}/>
        <div style={{position:"absolute",right:14,top:"50%",transform:"translateY(-50%)",fontSize:18,opacity:0.4}}>🔒</div>
      </div>
    </div>

    {/* ── NEW PIN FIELD ── */}
    <div style={{marginBottom:20}}>
      <label style={authLabel}>4‑Digit PIN</label>
      <div style={{position:"relative"}}>
        <input
          type="password"
          maxLength={4}
          value={staffPin}
          onChange={e=>setStaffPin(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&handleStaffLogin()}
          placeholder="••••"
          style={{...authInput(staffErr), letterSpacing:8, fontSize:22, textAlign:"center", fontWeight:700}}
        />
      </div>
    </div>

    {staffErr&&<AuthError>{staffErr}</AuthError>}

    <button onClick={handleStaffLogin} disabled={staffLoading}
      style={authPrimaryBtn("#4F46E5",staffLoading)}>
      {staffLoading ? <LoadingDots color="#fff"/> : <>Sign in to dashboard <span style={{marginLeft:6}}>→</span></>}
    </button>

    <div style={{marginTop:12,padding:"10px 14px",background:"rgba(79,70,229,0.07)",borderRadius:10,fontSize:12,color:"#4F46E5",textAlign:"center"}}>
      For support <strong>Contact Admin</strong>
    </div>
  </AuthScreen>
);

  function handleStaffLogin(){
  setStaffLoading(true);
  setTimeout(()=>{
    if(staffPwd === "Chetana@1996" && staffPin === "1991"){
      setView("staff");
      setStaffErr("");
      setStaffPwd("");
      setStaffPin("");
    } else {
      setStaffErr("Incorrect password or PIN. Please try again.");
    }
    setStaffLoading(false);
  }, 600);
}

  if(view==="student_login") return (
    <AuthScreen
      icon="🎓"
      iconBg="linear-gradient(135deg,#10B981,#34D399)"
      title="Student Portal"
      subtitle="View your project updates, content, and payment receipts"
      accentColor="#10B981"
      accentLight="#ECFDF5"
      onBack={()=>setView("home")}
    >
      <div style={{marginBottom:14}}>
        <label style={authLabel}>Project ID</label>
        <input value={projectIdInput} onChange={e=>setProjectIdInput(e.target.value.toUpperCase())}
          placeholder="e.g. P1, P2, P3"
          style={authInput(studentErr&&!projectIdInput)}/>
      </div>
      <div style={{marginBottom:20}}>
        <label style={authLabel}>4-Digit PIN</label>
        <div style={{position:"relative"}}>
          <input type="password" value={studentPin} onChange={e=>setStudentPin(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&handleStudentLogin()}
            maxLength={4} placeholder="••••"
            style={{...authInput(studentErr&&!studentPin),letterSpacing:8,fontSize:22,textAlign:"center",fontWeight:700}}/>
        </div>
        {studentErr&&<AuthError>{studentErr}</AuthError>}
      </div>
      <button onClick={handleStudentLogin} disabled={studentLoading}
        style={authPrimaryBtn("#10B981",studentLoading)}>
        {studentLoading ? <LoadingDots color="#fff"/> : <>Open my project portal <span style={{marginLeft:6}}>→</span></>}
      </button>
      
    </AuthScreen>
  );

  function handleStudentLogin(){
    setStudentLoading(true);
    setTimeout(()=>{
      const proj = projects.find(p=>p.id.toLowerCase()===projectIdInput.toLowerCase().trim());
      if(!proj){ setStudentErr("Project ID not found. Check and try again."); setStudentLoading(false); return; }
      if(proj.portalPin!==studentPin){ setStudentErr("Incorrect PIN. Please try again."); setStudentLoading(false); return; }
      const updated = {...proj, contentBlocks: (proj.contentBlocks || []).map(b =>
    b.readAt ? b : { ...b, readAt: now() }
)};
      updateProject(updated);
      setStudentProject(updated);
      setView("student");
      setStudentErr(""); setStudentPin(""); setProjectIdInput(""); setStudentLoading(false);
    }, 700);
  }

  if(view==="staff") return <StaffDashboard
    projects={projects} setView={setView} staffTab={staffTab} setStaffTab={setStaffTab}
    activeProject={activeProject} setActiveProject={setActiveProject}
    updateProject={updateProject} addProject={addProject} showToast={showToast}
    toast={toast} setToast={setToast}
  />;

  if(view==="student"&&studentProject) return <StudentDashboard
    project={projects.find(p=>p.id===studentProject.id)||studentProject}
    setView={setView} tab={studentTab} setTab={setStudentTab}
    toast={toast} setToast={setToast}
  />;

  return null;
}

// ─── AUTH SCREEN COMPONENT ────────────────────────────────────────────────────
const authLabel = {fontSize:12,fontWeight:600,color:"var(--color-text-secondary)",display:"block",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.05em"};
const authInput = (hasErr) => ({
  width:"100%",
  padding:"12px 16px",
  borderRadius:12,
  border: hasErr ? "2px solid #F43F5E" : "2px solid #4F46E5", // Changed to purple border
  background:"rgba(255,255,255,0.05)",
  color:"var(--color-text-primary)",
  fontSize:15,
  boxSizing:"border-box",
  outline:"none",
  transition:"all 0.3s ease",
  '::placeholder': {
    color: "rgba(255,255,255,0.4)"
  }
});
const authPrimaryBtn = (bg,loading) => ({
  width:"100%",padding:"13px",borderRadius:12,border:"none",
  background:loading?"#94A3B8":bg,color:"#fff",fontSize:15,
  fontWeight:700,cursor:loading?"not-allowed":"pointer",
  display:"flex",alignItems:"center",justifyContent:"center",gap:4,
  transition:"opacity 0.2s",opacity:loading?0.8:1,
});
const AuthError = ({children}) => (
  <div style={{display:"flex",alignItems:"center",gap:6,marginTop:8,padding:"8px 12px",background:"#FFF1F2",border:"1px solid #FECDD3",borderRadius:8,fontSize:12,color:"#9F1239",fontWeight:500}}>
    <span>⚠️</span>{children}
  </div>
);
const LoadingDots = ({color="#fff"}) => (
  <span style={{display:"inline-flex",gap:4,alignItems:"center"}}>
    {[0,1,2].map(i=>(
      <span key={i} style={{width:6,height:6,borderRadius:"50%",background:color,animation:`pulse 1.2s ease-in-out ${i*0.2}s infinite`,display:"inline-block"}}/>
    ))}
    <style>{`@keyframes pulse{0%,80%,100%{opacity:0.2;transform:scale(0.8);}40%{opacity:1;transform:scale(1);}}`}</style>
  </span>
);

function AuthScreen({icon,iconBg,title,subtitle,accentColor,accentLight,onBack,children}){
  return (
    <div style={{minHeight:"100vh", background:"rgba(0, 0, 0, 0.3)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",padding:24,position:"relative",overflow:"hidden"}}>
      {/* Background decorative circles */}
      <div style={{position:"absolute",top:-100,right:-100,width:400,height:400,borderRadius:"50%",background:`${accentColor}0d`,pointerEvents:"none"}}/>
      <div style={{position:"absolute",bottom:-80,left:-80,width:300,height:300,borderRadius:"50%",background:"rgba(16,185,129,0.05)",pointerEvents:"none"}}/>
      
      {/* Logo top-left */}
      <div style={{position:"absolute",top:20,left:24,display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
          <img 
            src={COMPANY.logoEmoji} 
            alt="logo" 
            style={{width:"100%",height:"100%",objectFit:"contain"}} 
          />
        </div>
        <span style={{color:"rgba(255,255,255,0.7)",fontWeight:600,fontSize:14}}>{COMPANY.name}</span>
      </div>

      <div style={{width:"100%",maxWidth:420,position:"relative",zIndex:1}}>
        {/* Card */}
        <div style={{background:"var(--color-background-primary)",borderRadius:24,border:"1px solid var(--color-border-tertiary)",overflow:"hidden",boxShadow:"0 24px 80px rgba(0,0,0,0.4)"}}>
          {/* Card header band */}
          <div style={{background:`linear-gradient(135deg,${accentColor}18,${accentColor}08)`,borderBottom:"1px solid var(--color-border-tertiary)",padding:"28px 32px 24px"}}>
            <div style={{display:"flex",alignItems:"center",gap:16}}>
              <div style={{width:52,height:52,borderRadius:16,background:iconBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,boxShadow:`0 8px 24px ${accentColor}40`}}>
                {icon}
              </div>
              <div>
                <h2 style={{margin:0,fontSize:22,fontWeight:800,color:"var(--color-text-primary)"}}>{title}</h2>
                <p style={{margin:"4px 0 0",color:"var(--color-text-secondary)",fontSize:13,lineHeight:1.4}}>{subtitle}</p>
              </div>
            </div>
          </div>

          {/* Form body */}
          <div style={{padding:"24px 32px 28px"}}>
            {children}
          </div>
        </div>

        {/* Back link */}
        <button onClick={onBack} style={{marginTop:16,background:"transparent",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",gap:6,padding:"8px 0",width:"100%",justifyContent:"center"}}>
          ← Back to home
        </button>
      </div>
    </div>
  );
}

// ─── HOME ─────────────────────────────────────────────────────────────────────
function HomeView({setView,projects,addProject,showToast,toast,setToast}){
  const [form,setForm]=useState({
    studentName:"",
    email:"",
    phone:"",
    college:"",
    domain:DOMAINS[0],
    title:"",
    totalBudget:"",
    advancePaid:"",
    paymentMode:"Online",
    notes:""
  });
  
  // New state for multiple contacts
  const [contacts, setContacts] = useState([
    { id: genId(), name: "", email: "", phone: "", role: "Student" }
  ]);
  
  const [submitted,setSubmitted]=useState(null);
  const [err,setErr]=useState("");
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));

  // Contact management functions
  const addContact = () => {
    setContacts([...contacts, { id: genId(), name: "", email: "", phone: "", role: "Guardian" }]);
  };

  const removeContact = (id) => {
    if (contacts.length <= 1) {
      setErr("At least one contact is required.");
      return;
    }
    setContacts(contacts.filter(c => c.id !== id));
  };

  const updateContact = (id, field, value) => {
    setContacts(contacts.map(c => 
      c.id === id ? { ...c, [field]: value } : c
    ));
  };
  
          // Add this state near your other useState hooks
const [showCourseDetails, setShowCourseDetails] = useState(false);
const submit = async () => {
  const {studentName, email, phone, college, title, totalBudget, advancePaid} = form;
  
  // Validate main contact
  if(!studentName || !email || !phone || !college || !title ){
    setErr("Please fill all required fields.");
    return;
  }
  if(!/^\d{10}$/.test(phone)){
    setErr("Phone must be exactly 10 digits.");
    return;
  }
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
    setErr("Enter a valid email address.");
    return;
  }

  // Validate additional contacts
  for (let contact of contacts) {
    if (contact.name || contact.email || contact.phone) {
      if (!contact.name || !contact.email || !contact.phone) {
        setErr("If adding a contact, please fill all fields (name, email, phone).");
        return;
      }
      if (!/^\d{10}$/.test(contact.phone)) {
        setErr(`Phone number for ${contact.name || 'contact'} must be exactly 10 digits.`);
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) {
        setErr(`Email for ${contact.name || 'contact'} is invalid.`);
        return;
      }
    }
  }

  const pin = String(Math.floor(1000 + Math.random() * 9000));
  const receiptNo = genReceiptNo();
  
  // Generate the ID first
  const projectId = genId(); // This should generate a 6-digit number
  
  // Build contacts array
  const allContacts = [
    {
      id: genId(),
      name: studentName,
      email: email,
      phone: phone,
      role: "Student",
      addedAt: now()
    },
    ...contacts
      .filter(c => c.name && c.email && c.phone)
      .map(c => ({
        ...c,
        id: genId(),
        addedAt: now()
      }))
  ];

  

  const proj = {
    ...form,
    id: projectId, // Use the generated ID
    portalPin: pin,
    totalBudget: parseFloat(form.totalBudget) || 0,
    advancePaid: parseFloat(form.advancePaid) || 0,
    status: "Inquiry",
    createdAt: now(),
    deadline: "",            // ← new field
    projectScope: "",        // ← new field
    staff: STAFF_LIST[0],
    contentBlocks: [],
    contacts: allContacts,
    payments: [{
      id: genId(),
      amount: parseFloat(form.advancePaid),
      mode: form.paymentMode,
      date: now(),
      note: "Initial advance payment",
      receiptNo: receiptNo
    }],
  };
  
  try {
    const newProject = await addProject(proj);
    // Make sure we have the ID
    const finalProject = {
      ...newProject,
      id: newProject.id || projectId, // Use the returned ID or the one we generated
      pin: pin,
      receiptNo: receiptNo
    };
    setSubmitted(finalProject);
    setErr("");
  } catch (error) {
    console.error("Error submitting project:", error);
    setErr("Error submitting project. Please try again.");
  }
};
  if(submitted) return (
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0B1220 0%,#141E33 50%,#1a0a3e 100%)",display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{background:"#fff",borderRadius:24,padding:40,maxWidth:520,width:"100%",textAlign:"center",boxShadow:"0 32px 80px rgba(0,0,0,0.4)"}}>
        <div style={{width:72,height:72,borderRadius:"50%",background:"#ECFDF5",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px",fontSize:32}}>✅</div>
        <h2 style={{margin:"0 0 6px",fontSize:24,fontWeight:700,color:"#065F46"}}>Registered Successfully!</h2>
        <p style={{color:C.slate,fontSize:15,margin:"0 0 24px"}}>Your project has been submitted. Save your credentials below.</p>
        <div style={{background:"#EEF2FF",borderRadius:14,padding:"20px 24px",marginBottom:20,textAlign:"left"}}>
          <div style={{fontSize:13,color:"#4F46E5",fontWeight:700,marginBottom:10,textTransform:"uppercase",letterSpacing:"0.05em"}}>Your portal credentials</div>
          {[["Project ID",submitted.id],["Your PIN",submitted.pin],["Receipt No",submitted.receiptNo],["Project",submitted.title],["Domain",submitted.domain]].map(([k,v])=>(
            <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:14,borderBottom:"1px solid #C7D2FE"}}>
              <span style={{color:"#4338CA"}}>{k}</span>
              <span style={{fontWeight:700,fontFamily:"monospace",color:"#312E81"}}>{v}</span>
            </div>
          ))}
          <div style={{marginTop:12,borderTop:"1px solid #C7D2FE",paddingTop:12}}>
            <div style={{fontSize:12,color:"#4F46E5",fontWeight:600,marginBottom:6}}>👥 Contacts Added</div>
            {submitted.contacts.map((c, i) => (
              <div key={i} style={{fontSize:12,color:"#4338CA",padding:"2px 0"}}>
                {c.name} ({c.role}) - {c.email} | {c.phone}
              </div>
            ))}
          </div>
        </div>
        <div style={{background:"#FFFBEB",borderRadius:12,padding:"12px 16px",fontSize:13,color:"#92400E",marginBottom:20,textAlign:"left"}}>
          ⚠️ <strong>Save your Project ID and PIN.</strong> You'll need them to access your student portal.
        </div>
        <button onClick={()=>{setSubmitted(null);setForm({studentName:"",email:"",phone:"",college:"",domain:DOMAINS[0],title:"",totalBudget:"",advancePaid:"",paymentMode:"Online",notes:""});setContacts([{id:genId(),name:"",email:"",phone:"",role:"Student"}]);}} style={primaryBtn("#4F46E5","#fff",{width:"100%",marginBottom:8})}>Register another project</button>
        <button onClick={()=>setView("student_login")} style={primaryBtn("#10B981","#fff",{width:"100%"})}>Go to my student portal →</button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0B1220 0%,#141E33 50%,#1a0a3e 100%)"}}>
      {toast&&<Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}
      <nav style={{padding:"16px 32px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
         <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
          <div>
            <div style={{color:"#fff",fontWeight:700,fontSize:16,lineHeight:1.1}}>{COMPANY.name}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:11}}>{COMPANY.tagline}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={()=>setView("student_login")} style={{...ghostBtn(),color:"rgba(255,255,255,0.7)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:10}}>🎓 Student portal</button>
          <button onClick={()=>setView("staff_login")} style={primaryBtn("#4F46E5","#fff",{borderRadius:10})}>Staff login →</button>
        </div>
      </nav>
      <div style={{maxWidth:1100,margin:"0 auto",padding:"48px 24px 60px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:48,alignItems:"center"}}>
        <div>
          <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(79,70,229,0.15)",border:"1px solid rgba(79,70,229,0.3)",borderRadius:99,padding:"5px 14px",fontSize:12,color:"#818CF8",marginBottom:20,fontWeight:600}}>
            🚀 ENGINEERING PROJECT CONSULTANCY
          </div>
          <h1 style={{margin:"0 0 16px",fontSize:42,fontWeight:800,color:"#fff",lineHeight:1.15,letterSpacing:"-0.02em"}}>
            From idea to<br/><span style={{background:"linear-gradient(90deg,#818CF8,#34D399)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>submission-ready</span><br/>project
          </h1>
          <p style={{color:"rgba(255,255,255,0.55)",fontSize:16,lineHeight:1.7,margin:"0 0 28px",maxWidth:420}}>
            IT · AIML · Mechatronics · Electronics · and more. We build your project and keep you updated — abstract, diagrams, code, synopsis, PPT.
          </p>


// ---- Hoarding Card (updated: Enroll Now opens modal) ----
<div style={{
  background:"linear-gradient(135deg, #4F46E5 0%, #4338CA 45%, #0F172A 100%)",
  border:"2px solid #818CF8",
  borderRadius:20,
  padding:"28px 26px",
  position:"relative",
  overflow:"hidden",
  boxShadow:"0 20px 60px -15px rgba(79,70,229,0.6)"
}}>
  <div style={{position:"absolute",top:-40,right:-40,width:160,height:160,background:"radial-gradient(circle, rgba(52,211,153,0.35), transparent 70%)"}}/>
  <div style={{position:"absolute",bottom:-50,left:-30,width:140,height:140,background:"radial-gradient(circle, rgba(129,140,248,0.35), transparent 70%)"}}/>

  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,position:"relative"}}>
    <div style={{display:"inline-flex",alignItems:"center",gap:6,background:"#F59E0B",color:"#1E1B0F",borderRadius:99,padding:"5px 12px",fontSize:11,fontWeight:800}}>
      🔥 ONLY 4 SEATS / BATCH
    </div>
    <div style={{background:"#34D399",color:"#052E22",borderRadius:99,padding:"5px 12px",fontSize:11,fontWeight:800}}>
      📍 OFFLINE ONLY
    </div>
  </div>

  <h3 style={{margin:"0 0 6px",fontSize:24,fontWeight:900,color:"#fff",lineHeight:1.2,position:"relative"}}>
    Class of <span style={{color:"#FDE68A"}}>React.js Development</span> + IoT
  </h3>
  <p style={{color:"rgba(255,255,255,0.8)",fontSize:13.5,lineHeight:1.6,margin:"0 0 18px",maxWidth:440,position:"relative"}}>
    Master React.js end-to-end — HTML → JS → React → Redux — and go further with AWS (IoT Core, Lambda) to connect ESP32 / ESP8266 & IoT devices for real-time data streaming.
  </p>

  <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20,position:"relative"}}>
    {["HTML to Redux","AWS IoT Core","ESP32 / ESP8266","Live Project + Hardware"].map(tag=>(
      <span key={tag} style={{fontSize:11.5,color:"#fff",background:"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.25)",borderRadius:8,padding:"5px 11px",fontWeight:700}}>{tag}</span>
    ))}
  </div>

  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(0,0,0,0.25)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:14,padding:"16px 18px",position:"relative"}}>
    <div>
      <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:600,marginBottom:2}}>COURSE FEE</div>
      <div style={{display:"flex",alignItems:"baseline",gap:6}}>
        <span style={{fontSize:28,fontWeight:900,color:"#34D399"}}>₹18,000</span>
        <span style={{fontSize:12,color:"rgba(255,255,255,0.5)",textDecoration:"line-through"}}>₹25,000</span>
      </div>
    </div>
    <div style={{width:1,height:36,background:"rgba(255,255,255,0.2)"}}/>
    <div style={{textAlign:"center"}}>
      <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:600,marginBottom:2}}>DURATION</div>
      <div style={{fontSize:20,fontWeight:900,color:"#fff"}}>2 Months</div>
    </div>
    <button onClick={()=>setShowCourseDetails(true)} style={{
      background:"linear-gradient(90deg,#F59E0B,#FBBF24)",
      color:"#1E1B0F",border:"none",borderRadius:10,
      padding:"10px 18px",fontWeight:800,fontSize:13,cursor:"pointer"
    }}>
      Enroll Now →
    </button>
  </div>
</div>

{/* ---- Course Details Modal ---- */}
{showCourseDetails && (
  <div style={{
    position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",
    display:"flex",alignItems:"center",justifyContent:"center",
    zIndex:1000,padding:20
  }} onClick={()=>setShowCourseDetails(false)}>
    <div onClick={(e)=>e.stopPropagation()} style={{
      background:"#0F172A",border:"1px solid rgba(129,140,248,0.3)",
      borderRadius:20,maxWidth:560,width:"100%",
      maxHeight:"85vh",overflowY:"auto",padding:"28px 28px 24px",
      position:"relative"
    }}>
      <button onClick={()=>setShowCourseDetails(false)} style={{
        position:"absolute",top:16,right:16,background:"rgba(255,255,255,0.08)",
        border:"none",color:"#fff",width:30,height:30,borderRadius:8,
        cursor:"pointer",fontSize:16
      }}>✕</button>

      <div style={{display:"inline-flex",alignItems:"center",gap:6,background:"#F59E0B",color:"#1E1B0F",borderRadius:99,padding:"5px 12px",fontSize:11,fontWeight:800,marginBottom:14}}>
        🔥 ONLY 4 SEATS PER BATCH · 2 BATCHES / MONTH
      </div>

      <h2 style={{margin:"0 0 6px",fontSize:22,fontWeight:900,color:"#fff"}}>
        React.js Development + IoT — Full Curriculum
      </h2>
      <p style={{color:"rgba(255,255,255,0.55)",fontSize:13,margin:"0 0 20px"}}>
        Offline batch · 2 Months · ₹18,000
      </p>

      <div style={{marginBottom:16}}>
        <div style={{color:"#818CF8",fontSize:12,fontWeight:800,marginBottom:8,letterSpacing:"0.03em"}}>FRONTEND FOUNDATIONS</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {["HTML","CSS","Bootstrap","Tailwind CSS","Material UI","JavaScript"].map(t=>(
            <span key={t} style={{fontSize:12,color:"#fff",background:"rgba(129,140,248,0.15)",border:"1px solid rgba(129,140,248,0.3)",borderRadius:8,padding:"5px 10px",fontWeight:600}}>{t}</span>
          ))}
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <div style={{color:"#34D399",fontSize:12,fontWeight:800,marginBottom:8,letterSpacing:"0.03em"}}>REACT ECOSYSTEM</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {["React.js","React Hooks","React Router","Redux","Redux Toolkit"].map(t=>(
            <span key={t} style={{fontSize:12,color:"#fff",background:"rgba(52,211,153,0.15)",border:"1px solid rgba(52,211,153,0.3)",borderRadius:8,padding:"5px 10px",fontWeight:600}}>{t}</span>
          ))}
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <div style={{color:"#FDE68A",fontSize:12,fontWeight:800,marginBottom:8,letterSpacing:"0.03em"}}>AWS CLOUD SERVICES</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {["IoT Core","S3 Bucket","Lambda","DynamoDB","Amplify"].map(t=>(
            <span key={t} style={{fontSize:12,color:"#fff",background:"rgba(245,158,11,0.15)",border:"1px solid rgba(245,158,11,0.3)",borderRadius:8,padding:"5px 10px",fontWeight:600}}>{t}</span>
          ))}
        </div>
      </div>

      <div style={{marginBottom:22}}>
        <div style={{color:"#F87171",fontSize:12,fontWeight:800,marginBottom:8,letterSpacing:"0.03em"}}>HARDWARE / IoT</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {["ESP32 Architecture","ESP8266","Sensor Integration","Real-time Data Streaming"].map(t=>(
            <span key={t} style={{fontSize:12,color:"#fff",background:"rgba(248,113,113,0.15)",border:"1px solid rgba(248,113,113,0.3)",borderRadius:8,padding:"5px 10px",fontWeight:600}}>{t}</span>
          ))}
        </div>
      </div>

      <a href="tel:9834455108" style={{
        display:"flex",alignItems:"center",justifyContent:"center",gap:8,
        background:"linear-gradient(90deg,#34D399,#10B981)",
        color:"#052E22",textDecoration:"none",
        borderRadius:12,padding:"14px 20px",fontWeight:900,fontSize:16
      }}>
        📞 Call Now to Enroll: 9834455108
      </a>
      <p style={{textAlign:"center",color:"rgba(255,255,255,0.4)",fontSize:11,margin:"10px 0 0"}}>
        Limited to 4 students per batch · 2 batches every month
      </p>
    </div>
  </div>
)}
        </div>
        
        {/* Registration Form */}
        <div style={{background:"rgba(255,255,255,0.04)",backdropFilter:"blur(20px)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:24,padding:28}}>
          <h3 style={{margin:"0 0 20px",color:"#fff",fontSize:18,fontWeight:700}}>Register your project</h3>
          
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            {[["studentName","Your full name","text",true,"1/-1"],["email","Email address","email",true,"1/2"],["phone","Phone number","tel",true,"2/3"],["college","College / University","text",true,"1/-1"]].map(([k,ph,type,req,col])=>(
              <div key={k} style={{gridColumn:col}}>
                <label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>{ph} {req&&"*"}</label>
                <input type={type} value={form[k]} onChange={e=>f(k,e.target.value)} placeholder={ph} style={darkInput()}/>
              </div>
            ))}
          </div>

          {/* Additional Contacts Section */}
          <div style={{marginTop:16,marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <label style={{fontSize:13,color:"rgba(255,255,255,0.7)",fontWeight:600}}>👥 Additional Contacts</label>
              <button 
                onClick={addContact}
                style={{
                  padding:"5px 14px",
                  borderRadius:8,
                  border:"1px solid rgba(255,255,255,0.2)",
                  background:"rgba(255,255,255,0.05)",
                  color:"#818CF8",
                  fontSize:12,
                  cursor:"pointer",
                  transition:"all 0.2s"
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(79,70,229,0.2)";
                  e.target.style.borderColor = "#4F46E5";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.05)";
                  e.target.style.borderColor = "rgba(255,255,255,0.2)";
                }}
              >
                + Add Contact
              </button>
            </div>
            
            {/* Contacts List */}
            {contacts.map((contact, index) => (
              <div key={contact.id} style={{
                background:"rgba(255,255,255,0.03)",
                borderRadius:12,
                padding:12,
                marginBottom:10,
                border:"1px solid rgba(255,255,255,0.06)"
              }}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <span style={{fontSize:12,color:"rgba(255,255,255,0.4)"}}>
                    Contact #{index + 1} {index === 0 ? "(Primary)" : ""}
                  </span>
                  {index > 0 && (
                    <button
                      onClick={() => removeContact(contact.id)}
                      style={{
                        padding:"3px 10px",
                        borderRadius:6,
                        border:"1px solid rgba(244,63,94,0.3)",
                        background:"rgba(244,63,94,0.1)",
                        color:"#FDA4AF",
                        fontSize:11,
                        cursor:"pointer",
                        transition:"all 0.2s"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = "rgba(244,63,94,0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "rgba(244,63,94,0.1)";
                      }}
                    >
                      ✕ Remove
                    </button>
                  )}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                  <input
                    placeholder="Name"
                    value={contact.name}
                    onChange={(e) => updateContact(contact.id, "name", e.target.value)}
                    style={darkInputContact()}
                  />
                  <input
                    placeholder="Email"
                    value={contact.email}
                    onChange={(e) => updateContact(contact.id, "email", e.target.value)}
                    style={darkInputContact()}
                  />
                  <input
                    placeholder="Phone"
                    value={contact.phone}
                    onChange={(e) => updateContact(contact.id, "phone", e.target.value)}
                    style={darkInputContact()}
                  />
                </div>
                {index === 0 && (
                  <div style={{marginTop:6,fontSize:11,color:"rgba(255,255,255,0.3)"}}>
                    ℹ️ This is the primary contact (Student)
                  </div>
                )}
              </div>
            ))}
            <div style={{fontSize:11,color:"rgba(255,255,255,0.3)",marginTop:4}}>
              Add guardian, parent, or co-author contact information (optional)
            </div>
          </div>

          {/* Rest of the form */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginTop:12}}>
            <div><label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Domain *</label>
              <select value={form.domain} onChange={e=>f("domain",e.target.value)} style={darkInput()}>
                {DOMAINS.map(d=><option key={d} style={{background:"#141E33"}}>{d}</option>)}
              </select>
            </div>
            <div><label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Payment mode</label>
              <select value={form.paymentMode} onChange={e=>f("paymentMode",e.target.value)} style={darkInput()}>
                <option style={{background:"#141E33"}}>Online</option>
                <option style={{background:"#141E33"}}>Cash</option>
              </select>
            </div>
          </div>
          
          <div style={{marginTop:12}}>
            <label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Project title *</label>
            <input value={form.title} onChange={e=>f("title",e.target.value)} placeholder="Brief title for your project idea" style={darkInput()}/>
          </div>
          
          {/* <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginTop:4}}>
            <div><label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Total budget (₹) *</label>
              <input type="number" value={form.totalBudget} onChange={e=>f("totalBudget",e.target.value)} placeholder="15000" style={darkInput()}/>
            </div>
            <div><label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Advance paid (₹) *</label>
              <input type="number" value={form.advancePaid} onChange={e=>f("advancePaid",e.target.value)} placeholder="5000" style={darkInput()}/>
            </div>
          </div> */}
          
          <div style={{marginTop:4}}>
            <label style={{fontSize:12,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:5}}>Notes / description</label>
            <textarea value={form.notes} onChange={e=>f("notes",e.target.value)} rows={2} placeholder="Tech stack, deadline, ideas..." style={{...darkInput(),resize:"vertical"}}/>
          </div>

          {err&&<div style={{background:"rgba(244,63,94,0.15)",border:"1px solid rgba(244,63,94,0.3)",borderRadius:8,padding:"10px 14px",fontSize:13,color:"#FDA4AF",marginTop:12}}>{err}</div>}
          <button onClick={submit} style={primaryBtn("#4F46E5","#fff",{width:"100%",marginTop:16,padding:"12px",fontSize:15,fontWeight:700})}>Submit project enquiry →</button>
        </div>
      </div>
    </div>
  );
}

// Helper function for contact input styling
function darkInputContact(extra={}){
  return {
    width:"100%",
    padding:"8px 10px",
    borderRadius:8,
    border:"1px solid rgba(255,255,255,0.1)",
    background:"rgba(255,255,255,0.05)",
    color:"#fff",
    fontSize:13,
    boxSizing:"border-box",
    outline:"none",
    transition:"all 0.2s",
    '::placeholder': {
      color: "rgba(255,255,255,0.3)"
    },
    ...extra
  };
}

// ─── STAFF DASHBOARD ──────────────────────────────────────────────────────────
function StaffDashboard({projects, setView, staffTab, setStaffTab, activeProject, setActiveProject, updateProject, addProject, showToast, toast, setToast}) {
  const [search, setSearch] = useState("");
  const [fDomain, setFDomain] = useState("All");
  const [fStatus, setFStatus] = useState("All");
  const [fStaff, setFStaff] = useState("All");

  // Ensure projects is always an array
  const safeProjects = Array.isArray(projects) ? projects : [];
  
  const filtered = safeProjects.filter(p => {
    if (!p) return false;
    const s = search.toLowerCase();
    return (!s || (p.studentName?.toLowerCase().includes(s) || 
                   p.title?.toLowerCase().includes(s) || 
                   p.college?.toLowerCase().includes(s) || 
                   p.email?.toLowerCase().includes(s)))
      && (fDomain === "All" || p.domain === fDomain)
      && (fStatus === "All" || p.status === fStatus)
      && (fStaff === "All" || p.staff === fStaff);
  });

  const total = arr => arr?.reduce((a, b) => a + (b?.totalBudget || 0), 0) || 0;
  const collected = arr => arr?.reduce((a, b) => a + (b?.advancePaid || 0), 0) || 0;
  const unreadTotal = safeProjects.reduce((a, p) => a + (p?.contentBlocks?.filter(b => !b?.readAt)?.length || 0), 0);

  // Show loading if projects is undefined or null
  if (!projects || !Array.isArray(projects)) {
    return (
      <div style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.bg}}>
        <div style={{textAlign: "center"}}>
          <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
          <div style={{fontSize: 18, fontWeight: 600}}>Loading projects...</div>
        </div>
      </div>
    );
  }

  if (activeProject) {
    const project = safeProjects.find(x => x?.id === activeProject.id) || activeProject;
    return <ProjectDetail 
      project={project}
      onBack={() => setActiveProject(null)} 
      updateProject={updateProject} 
      showToast={showToast}
    />;
  }

  return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",background:C.bg}}>
      {toast&&<Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}
      <div style={{background:C.navy,padding:"0 24px",display:"flex",alignItems:"center",borderBottom:`1px solid ${C.navyBorder}`,position:"sticky",top:0,zIndex:20}}>
        <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 0",marginRight:32}}>
          <div style={{width:32,height:32,borderRadius:8,overflow:"hidden",flexShrink:0}}>
  <img 
    src={COMPANY.logoEmoji} 
    alt="logo" 
    style={{width:"100%",height:"100%",objectFit:"contain"}} 
  />
</div>
          <span style={{color:"#fff",fontWeight:700,fontSize:15}}>{COMPANY.name}</span>
        </div>
        {["overview","projects","contacts","payments","content"].map(t=>(
          <button key={t} onClick={()=>setStaffTab(t)} style={{padding:"16px 16px",background:"transparent",border:"none",cursor:"pointer",fontSize:13,fontWeight:staffTab===t?600:400,
            color:staffTab===t?"#818CF8":"rgba(255,255,255,0.45)",borderBottom:staffTab===t?"2px solid #818CF8":"2px solid transparent",textTransform:"capitalize"}}>
            {t==="content"?<span>Content <span style={{background:"#4F46E5",borderRadius:99,padding:"1px 7px",fontSize:10,marginLeft:4}}>{unreadTotal}</span></span>:t}
          </button>
        ))}
        <div style={{marginLeft:"auto"}}>
          <button onClick={()=>setView("home")} style={{...ghostBtn(),color:"rgba(255,255,255,0.5)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,fontSize:13}}>Sign out</button>
        </div>
      </div>

      <div style={{flex:1,maxWidth:1200,margin:"0 auto",width:"100%",padding:"24px 20px"}}>

        {staffTab==="overview"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <h2 style={{margin:0,fontSize:22,fontWeight:700}}>Overview</h2>
              <span style={{fontSize:13,color:C.muted}}>{new Date().toLocaleDateString("en-IN",{weekday:"long",day:"numeric",month:"long"})}</span>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:14,marginBottom:24}}>
              {[
                {label:"Total projects",value:safeProjects.length,icon:"📁",color:"#4F46E5",bg:"#EEF2FF"},
                {label:"Total revenue",value:`₹${total(safeProjects).toLocaleString("en-IN")}`,icon:"💰",color:"#059669",bg:"#ECFDF5"},
                {label:"Collected",value:`₹${collected(safeProjects).toLocaleString("en-IN")}`,icon:"✅",color:"#0891B2",bg:"#ECFEFF"},
                {label:"Pending dues",value:`₹${(total(safeProjects)-collected(safeProjects)).toLocaleString("en-IN")}`,icon:"⏳",color:"#D97706",bg:"#FFFBEB"},
                {label:"Total contacts",value:safeProjects.reduce((a,p)=>a+(p?.contacts?.length||0),0),icon:"👥",color:"#7C3AED",bg:"#F5F3FF"},
                {label:"Unread by students",value:unreadTotal,icon:"🔔",color:"#9333EA",bg:"#FAF5FF"},
              ].map(({label,value,icon,color,bg})=>(
                <div key={label} style={{background:bg,borderRadius:14,padding:"16px 18px"}}>
                  <div style={{fontSize:22,marginBottom:6}}>{icon}</div>
                  <div style={{fontSize:12,color,fontWeight:600,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.04em"}}>{label}</div>
                  <div style={{fontSize:22,fontWeight:700,color}}>{value}</div>
                </div>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
              <Card>
                <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:600}}>Domain breakdown</h3>
                {DOMAINS.map(d=>{
                  const cnt=safeProjects.filter(p=>p?.domain===d).length;
                  if(!cnt) return null;
                  const pct=Math.round((cnt/safeProjects.length)*100);
                  return <div key={d} style={{marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:4}}>
                      <span style={{fontWeight:500}}>{d}</span><span style={{color:C.muted}}>{cnt} project{cnt>1?"s":""}</span>
                    </div>
                    <div style={{height:6,borderRadius:99,background:C.surface}}>
                      <div style={{height:"100%",width:`${pct}%`,background:"linear-gradient(90deg,#4F46E5,#818CF8)",borderRadius:99}}/>
                    </div>
                  </div>;
                })}
              </Card>
              <Card>
                <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:600}}>Staff workload</h3>
                {STAFF_LIST.map(s=>{
                  const myP=safeProjects.filter(p=>p?.staff===s);
                  if(!myP.length) return null;
                  const rev=myP.reduce((a,b)=>a+(b?.totalBudget||0),0);
                  return <div key={s} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <Avatar name={s} size={32} bg="#EEF2FF" color="#4F46E5"/>
                      <span style={{fontSize:13,fontWeight:500}}>{s}</span>
                    </div>
                    <div style={{display:"flex",gap:10,alignItems:"center"}}>
                      <span style={{fontSize:12,color:C.muted}}>₹{rev.toLocaleString("en-IN")}</span>
                      <span style={{background:"#EEF2FF",color:"#4F46E5",fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:99}}>{myP.length} projects</span>
                    </div>
                  </div>;
                })}
              </Card>
            </div>
          </div>
        )}

        {staffTab==="projects"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <h2 style={{margin:0,fontSize:22,fontWeight:700}}>Projects ({filtered.length})</h2>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:10,marginBottom:14}}>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search student, title, college, email..." style={inputStyle({margin:0})}/>
              <select value={fDomain} onChange={e=>setFDomain(e.target.value)} style={inputStyle({margin:0})}><option value="All">All domains</option>{DOMAINS.map(d=><option key={d}>{d}</option>)}</select>
              <select value={fStatus} onChange={e=>setFStatus(e.target.value)} style={inputStyle({margin:0})}><option value="All">All statuses</option>{STATUSES.map(s=><option key={s}>{s}</option>)}</select>
              <select value={fStaff} onChange={e=>setFStaff(e.target.value)} style={inputStyle({margin:0})}><option value="All">All staff</option>{STAFF_LIST.map(s=><option key={s}>{s}</option>)}</select>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {filtered.map(p=>(
                <div key={p.id} onClick={()=>setActiveProject(p)}
                  style={{background:C.card,borderRadius:14,border:`1px solid ${C.border}`,padding:"16px 20px",cursor:"pointer",display:"flex",gap:16,alignItems:"center"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor=C.indigo;e.currentTarget.style.boxShadow="0 4px 16px rgba(79,70,229,0.08)";}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.boxShadow="none";}}>
                  <Avatar name={p.studentName} size={44} bg="#EEF2FF" color="#4F46E5"/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
                      <span style={{fontWeight:600,fontSize:15}}>{p.studentName}</span>
                      <Badge status={p.status}>{p.status}</Badge>
                      {p.contentBlocks?.filter(b=>!b.readAt)?.length>0&&(
                        <span style={{background:"#4F46E5",color:"#fff",fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:99}}>{p.contentBlocks.filter(b=>!b.readAt).length} unread</span>
                      )}
                    </div>
                    <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{p.title}</div>
                    <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:12,color:C.muted}}>
                      <span>📚 {p.domain}</span>
                      <span>🏛️ {p.college}</span>
                      <span>👤 {p.staff}</span>
                      <span>👥 {(p.contacts||[]).length} contacts</span>
                      <span>🧾 {(p.payments||[]).length} payments</span>
                    </div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{fontSize:16,fontWeight:700,color:"#059669"}}>₹{p.totalBudget.toLocaleString("en-IN")}</div>
                    <div style={{fontSize:16,fontWeight:700,color:"#059669"}}>
  ₹{(p.totalBudget || 0).toLocaleString("en-IN")}
</div>
<div style={{fontSize:12,color:(p.advancePaid||0)<(p.totalBudget||0)?"#D97706":"#059669"}}>
  {(p.advancePaid||0) < (p.totalBudget||0)
    ? `₹${((p.totalBudget||0) - (p.advancePaid||0)).toLocaleString("en-IN")} due`
    : "Fully paid"}
</div>
                    <div style={{fontSize:11,color:C.muted,marginTop:2}}>ID: {p.id}</div>
                  </div>
                </div>
              ))}
              {filtered.length===0&&<div style={{textAlign:"center",color:C.muted,padding:60,fontSize:15}}>No projects match your filters.</div>}
            </div>
          </div>
        )}

        {staffTab==="contacts"&&(
          <div>
            <h2 style={{margin:"0 0 6px",fontSize:22,fontWeight:700}}>All Contacts</h2>
            <p style={{color:C.muted,fontSize:14,margin:"0 0 16px"}}>All contacts across all projects — click a project to add more</p>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, email, phone..." style={inputStyle({marginBottom:16})}/>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:14}}>
              {safeProjects.flatMap(p => (p?.contacts || []).map(c => ({...c, project: p})))
                .filter(c => !search || (c.name?.toLowerCase().includes(search.toLowerCase()) || 
                                        c.email?.toLowerCase().includes(search.toLowerCase()) || 
                                        c.phone?.includes(search)))
                .map(c => (
                <Card key={c.id}>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
                    <Avatar name={c.name} size={44} bg="#EEF2FF" color="#4F46E5"/>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:600,fontSize:15}}>{c.name}</div>
                      <div style={{fontSize:11,color:"#4F46E5",fontWeight:600,background:"#EEF2FF",display:"inline-block",padding:"2px 8px",borderRadius:99,marginTop:2}}>{c.role}</div>
                    </div>
                  </div>
                  <div style={{fontSize:13}}>
                    <div style={{padding:"6px 0",borderBottom:`1px solid ${C.border}`,color:"#4F46E5"}}>{c.email}</div>
                    <div style={{padding:"6px 0",borderBottom:`1px solid ${C.border}`,color:C.muted}}>📞 {c.phone}</div>
                    <div style={{padding:"6px 0",borderBottom:`1px solid ${C.border}`,color:C.muted,fontSize:12}}>Project: <span style={{color:C.text,fontWeight:500}}>{c.project?.title}</span></div>
                    <div style={{padding:"6px 0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <Badge status={c.project?.status}>{c.project?.status}</Badge>
                      <span style={{fontSize:11,color:C.muted}}>Added {fmtDate(c.addedAt)}</span>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}

        {staffTab==="payments"&&(
          <div>
            <h2 style={{margin:"0 0 6px",fontSize:22,fontWeight:700}}>Payment Records</h2>
            <p style={{color:C.muted,fontSize:14,margin:"0 0 20px"}}>All payment transactions — click "View Receipt" to print</p>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {safeProjects.flatMap(p => (p?.payments || []).map(pay => ({...pay, project: p})))
                .sort((a,b)=>new Date(b.date)-new Date(a.date))
                .map(pay=><PaymentRow key={pay.id} payment={pay} project={pay.project}/>)}
            </div>
          </div>
        )}

        {staffTab==="content"&&(
          <div>
            <h2 style={{margin:"0 0 6px",fontSize:22,fontWeight:700}}>Content delivery tracker</h2>
            <p style={{color:C.muted,fontSize:14,margin:"0 0 20px"}}>All content blocks sent to students</p>
            {CONTENT_TYPES.map(ct=>{
              const blocks = safeProjects.flatMap(p => 
                (p?.contentBlocks || [])
                  .filter(b => b?.type === ct.id)
                  .map(b => ({...b, studentName: p?.studentName, projectId: p?.id, projectTitle: p?.title}))
              );
              if(!blocks.length) return null;
              return <div key={ct.id} style={{marginBottom:24}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <span style={{fontSize:20}}>{ct.icon}</span>
                  <h3 style={{margin:0,fontSize:15,fontWeight:600}}>{ct.label}</h3>
                  <span style={{background:ct.bg,color:ct.color,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:99}}>{blocks.length}</span>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {blocks.map(b=>(
                    <div key={b.id} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <span style={{fontWeight:500,fontSize:13}}>{b.title}</span>
                        <span style={{color:C.muted,fontSize:12}}> → {b.studentName} ({b.projectTitle})</span>
                        <div style={{fontSize:12,color:C.muted,marginTop:2}}>Sent {fmtDateTime(b.sentAt)} by {b.sentBy}</div>
                      </div>
                      <span style={{fontSize:11,padding:"4px 12px",borderRadius:99,fontWeight:600,
                        background:b.readAt?"#ECFDF5":"#FFFBEB",color:b.readAt?"#065F46":"#92400E"}}>
                        {b.readAt?`✓ Read ${fmtDate(b.readAt)}`:"Unread"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>;
            })}
          </div>
        )}
      </div>
    </div>
  );
}

function PaymentRow({payment,project}){
  const [showReceipt,setShowReceipt]=useState(false);
  // Safe fallbacks for any missing data
  const amount = payment?.amount ?? 0;
  const totalBudget = project?.totalBudget ?? 0;
  const studentName = project?.studentName ?? "";
  const title = project?.title ?? "";

  return <>
    {showReceipt&&<ReceiptModal project={project} payment={payment} onClose={()=>setShowReceipt(false)}/>}
    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 20px",display:"flex",alignItems:"center",gap:16}}>
      <div style={{width:44,height:44,borderRadius:12,background:"#ECFDF5",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🧾</div>
      <div style={{flex:1}}>
        <div style={{fontWeight:600,fontSize:14}}>{studentName} <span style={{color:C.muted,fontWeight:400,fontSize:13}}>· {title}</span></div>
        <div style={{fontSize:12,color:C.muted,marginTop:3}}>
          {payment?.receiptNo} · {fmtDate(payment?.date)} · {payment?.mode}
          {payment?.note&&<> · {payment.note}</>}
        </div>
      </div>
      <div style={{textAlign:"right",flexShrink:0,marginRight:12}}>
        <div style={{fontSize:18,fontWeight:700,color:"#059669"}}>₹{amount.toLocaleString("en-IN")}</div>
        <div style={{fontSize:11,color:C.muted}}>of ₹{totalBudget.toLocaleString("en-IN")}</div>
      </div>
      <button onClick={()=>setShowReceipt(true)} style={primaryBtn("#4F46E5","#fff",{fontSize:12,padding:"7px 16px",whiteSpace:"nowrap"})}>
        🖨️ Receipt
      </button>
    </div>
  </>;
}

// ─── PROJECT DETAIL ───────────────────────────────────────────────────────────
// ─── PROJECT DETAIL ───────────────────────────────────────────────────────────
function ProjectDetail({project, onBack, updateProject, showToast}) {
  // All hooks must be called BEFORE any conditional returns
  const [tab, setTab] = useState("content");
  const [showAddContent, setShowAddContent] = useState(false);
  const [showAddContact, setShowAddContact] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showProcessPDF, setShowProcessPDF] = useState(false);
  const [showReceipt, setShowReceipt] = useState(null);
  const [editInfo, setEditInfo] = useState(false);
  const [infoForm, setInfoForm] = useState({...project});
  const [newBlock, setNewBlock] = useState({type: CONTENT_TYPES[0].id, title: "", body: ""});
  const [newContact, setNewContact] = useState({name: "", email: "", phone: "", role: "Guardian"});
  const [newPayment, setNewPayment] = useState({amount: "", mode: "Online", note: ""});
  const [toast, setToast] = useState(null);

  // NOW check if project exists after all hooks
  if (!project) {
    return (
      <div style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFFFFF"}}>
        <div style={{textAlign: "center"}}>
          <div style={{fontSize: 40, marginBottom: 16}}>📁</div>
          <div style={{fontSize: 18, fontWeight: 600}}>Project not found</div>
        </div>
      </div>
    );
  }

  // Use optional chaining and null checks everywhere
  const pending = (project?.totalBudget || 0) - (project?.advancePaid || 0);
  const unread = project?.contentBlocks?.filter(b => !b?.readAt)?.length || 0;
  const contacts = project?.contacts || [];
  const payments = project?.payments || [];

  const sendContent = () => {
    if (!newBlock.title || !newBlock.body) {
      setToast({msg: "Title and content required.", type: "error"});
      return;
    }
    const block = {...newBlock, id: genId(), sentAt: now(), sentBy: "Staff", readAt: null};
    updateProject({
      ...project,
      contentBlocks: [...(project?.contentBlocks || []), block]
    });
    setNewBlock({type: CONTENT_TYPES[0].id, title: "", body: ""});
    setShowAddContent(false);
    setToast({msg: `"${block.title}" sent!`, type: "success"});
  };

  const deleteBlock = (id) => {
    updateProject({
      ...project,
      contentBlocks: (project?.contentBlocks || []).filter(b => b.id !== id)
    });
  };

  const addContact = () => {
    if (!newContact.name || !newContact.email || !newContact.phone) {
      setToast({msg: "Fill all contact fields.", type: "error"});
      return;
    }
    if (!/^\d{10}$/.test(newContact.phone)) {
      setToast({msg: "Phone must be 10 digits.", type: "error"});
      return;
    }
    const c = {...newContact, id: genId(), addedAt: now()};
    updateProject({
      ...project,
      contacts: [...(project?.contacts || []), c]
    });
    setNewContact({name: "", email: "", phone: "", role: "Guardian"});
    setShowAddContact(false);
    setToast({msg: `${c.name} added as contact.`, type: "success"});
  };

  const deleteContact = (id) => {
    if ((project?.contacts || []).length <= 1) {
      setToast({msg: "At least one contact required.", type: "error"});
      return;
    }
    updateProject({
      ...project,
      contacts: (project?.contacts || []).filter(c => c.id !== id)
    });
  };

  const addPayment = () => {
    const amt = parseFloat(newPayment.amount);
    if (!amt || amt <= 0) {
      setToast({msg: "Enter a valid amount.", type: "error"});
      return;
    }
    const receiptNo = genReceiptNo();
    const pay = {...newPayment, amount: amt, id: genId(), date: now(), receiptNo};
    const newTotal = (project?.advancePaid || 0) + amt;
    updateProject({
      ...project,
      advancePaid: newTotal,
      payments: [...(project?.payments || []), pay]
    });
    setNewPayment({amount: "", mode: "Online", note: ""});
    setShowAddPayment(false);
    setToast({msg: `₹${amt.toLocaleString("en-IN")} recorded. Receipt: ${receiptNo}`, type: "success"});
  };

 const saveInfo = () => {
  const updated = {
    ...project,
    ...infoForm,
    totalBudget: (project.totalBudget || 0) > 0 
      ? project.totalBudget   // keep the existing value if already set
      : parseFloat(infoForm.totalBudget) || 0,
    advancePaid: parseFloat(infoForm.advancePaid) || 0,
    deadline: infoForm.deadline || "",          // save new field
    projectScope: infoForm.projectScope || "",  // save new field
  };
  updateProject(updated);
  setEditInfo(false);
  setToast({msg: "Project updated.", type: "success"});
};

  // Rest of your return statement with null checks
  return (
    <div style={{minHeight: "100vh", background: "#FFFFFF"}}>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={() => setToast(null)}/>}
      {showReceipt && <ReceiptModal project={project} payment={showReceipt} onClose={() => setShowReceipt(null)}/>}

      <div style={{background: C.card, borderBottom: `1px solid ${C.border}`, padding: "14px 24px", display: "flex", alignItems: "center", gap: 16, position: "sticky", top: 0, zIndex: 20}}>
        <button onClick={onBack} style={{...ghostBtn(), display: "flex", alignItems: "center", gap: 6, fontSize: 13}}>← All projects</button>
        <div style={{flex: 1}}>
          <div style={{display: "flex", alignItems: "center", gap: 12}}>
            <Avatar name={project?.studentName || "Unknown"} size={36} bg="#EEF2FF" color="#4F46E5"/>
            <div>
              <div style={{fontWeight: 700, fontSize: 16}}>{project?.studentName || "Unknown"}</div>
              <div style={{fontSize: 12, color: C.muted}}>{project?.title || "No title"}</div>
            </div>
            <Badge status={project?.status}>{project?.status}</Badge>
            {unread > 0 && <span style={{background: "#4F46E5", color: "#fff", fontSize: 11, padding: "2px 10px", borderRadius: 99, fontWeight: 700}}>{unread} unread</span>}
          </div>
        </div>
        <div style={{display: "flex", gap: 8}}>
          <button onClick={() => setShowAddPayment(true)} style={primaryBtn("#059669", "#fff", {fontSize: 13})}>+ Payment</button>
          <button onClick={() => setShowAddContent(true)} style={primaryBtn("#4F46E5", "#fff", {fontSize: 13})}>+ Content</button>
        </div>
      </div>

      <div style={{maxWidth: 1000, margin: "0 auto", padding: "24px 20px"}}>
        {/* Stats cards */}
        <div style={{display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 12, marginBottom: 20}}>
          {[
            {label: "Budget", v: `₹${(project?.totalBudget || 0).toLocaleString("en-IN")}`, c: "#059669", bg: "#ECFDF5"},
            {label: "Collected", v: `₹${(project?.advancePaid || 0).toLocaleString("en-IN")}`, c: "#0891B2", bg: "#ECFEFF"},
            {label: "Due", v: `₹${pending.toLocaleString("en-IN")}`, c: pending > 0 ? "#D97706" : "#059669", bg: pending > 0 ? "#FFFBEB" : "#ECFDF5"},
            {label: "Contacts", v: contacts.length, c: "#7C3AED", bg: "#F5F3FF"},
            {label: "Content", v: project?.contentBlocks?.length || 0, c: "#4F46E5", bg: "#EEF2FF"},
          ].map(({label, v, c, bg}) => (
            <div key={label} style={{background: bg, borderRadius: 12, padding: "12px 16px"}}>
              <div style={{fontSize: 11, color: c, fontWeight: 600, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.04em"}}>{label}</div>
              <div style={{fontSize: 20, fontWeight: 700, color: c}}>{v}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{display: "flex", gap: 2, marginBottom: 20, background: C.surface, borderRadius: 10, padding: 4, border: `1px solid ${C.border}`}}>
          {["content", "contacts", "payments", "info"].map(t => (
            <button key={t} onClick={() => setTab(t)} style={{
              flex: 1,
              padding: "8px 0",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
              background: tab === t ? C.card : "transparent",
              color: tab === t ? C.indigo : C.muted,
              textTransform: "capitalize"
            }}>
              {t === "content" ? `Content (${project?.contentBlocks?.length || 0})` :
               t === "contacts" ? `Contacts (${contacts.length})` :
               t === "payments" ? `Payments (${payments.length})` : t}
            </button>
          ))}
        </div>

        {/* CONTENT TAB */}
        {tab === "content" && (
          <div>
            {(project?.contentBlocks || []).length === 0 && <div style={{textAlign: "center", padding: "60px 20px", color: C.muted}}>
              <div style={{fontSize: 40, marginBottom: 12}}>📭</div>
              <div style={{fontSize: 16, fontWeight: 500}}>No content sent yet</div>
            </div>}
            <div style={{display: "flex", flexDirection: "column", gap: 14}}>
              {[...(project?.contentBlocks || [])].reverse().map(block => {
                const ctType = CONTENT_TYPES.find(c => c.id === block.type) || CONTENT_TYPES[0];
                return <Card key={block.id} style={{borderLeft: `4px solid ${ctType.color}`}}>
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10}}>
                    <div style={{display: "flex", alignItems: "center", gap: 10}}>
                      <span style={{fontSize: 22}}>{ctType.icon}</span>
                      <div>
                        <div style={{fontWeight: 600, fontSize: 15}}>{block.title}</div>
                        <div style={{fontSize: 12, color: C.muted}}>
                          <span style={{background: ctType.bg, color: ctType.color, padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600, marginRight: 8}}>{ctType.label}</span>
                          Sent {fmtDateTime(block.sentAt)} by {block.sentBy}
                        </div>
                      </div>
                    </div>
                    <div style={{display: "flex", gap: 8, alignItems: "center"}}>
                      <span style={{
                        fontSize: 11,
                        padding: "4px 12px",
                        borderRadius: 99,
                        fontWeight: 600,
                        background: block.readAt ? "#ECFDF5" : "#FFFBEB",
                        color: block.readAt ? "#065F46" : "#92400E"
                      }}>
                        {block.readAt ? `✓ Read ${fmtDate(block.readAt)}` : "Unread"}
                      </span>
                      <button onClick={() => deleteBlock(block.id)} style={{...ghostBtn(), fontSize: 12, color: "#9F1239", padding: "4px 10px"}}>✕</button>
                    </div>
                  </div>
                  <div style={{background: C.surface, borderRadius: 10, padding: "14px 16px", fontSize: 13, lineHeight: 1.8, whiteSpace: "pre-wrap", fontFamily: block.type === "code" ? "monospace" : "inherit"}}>
                    {block.body}
                  </div>
                </Card>;
              })}
            </div>
          </div>
        )}

        {/* CONTACTS TAB */}
        {tab === "contacts" && (
          <div>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16}}>
              <h3 style={{margin: 0, fontSize: 16, fontWeight: 600}}>Project Contacts</h3>
              <button onClick={() => setShowAddContact(true)} style={primaryBtn("#4F46E5", "#fff", {fontSize: 13})}>+ Add contact</button>
            </div>
            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14}}>
              {contacts.map(c => (
                <Card key={c.id}>
                  <div style={{display: "flex", alignItems: "center", gap: 12, marginBottom: 12}}>
                    <Avatar name={c.name} size={44} bg="#EEF2FF" color="#4F46E5"/>
                    <div style={{flex: 1}}>
                      <div style={{fontWeight: 600, fontSize: 15}}>{c.name}</div>
                      <span style={{background: "#EEF2FF", color: "#4F46E5", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 99}}>{c.role}</span>
                    </div>
                    {contacts.length > 1 && <button onClick={() => deleteContact(c.id)} style={{...ghostBtn(), fontSize: 12, color: "#9F1239", padding: "4px 10px"}}>✕</button>}
                  </div>
                  <div style={{fontSize: 13}}>
                    <div style={{padding: "6px 0", borderBottom: `1px solid ${C.border}`, color: "#4F46E5"}}>{c.email}</div>
                    <div style={{padding: "6px 0", borderBottom: `1px solid ${C.border}`, color: C.muted}}>📞 {c.phone}</div>
                    <div style={{padding: "6px 0", fontSize: 12, color: C.muted}}>Added {fmtDate(c.addedAt)}</div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}

        {/* PAYMENTS TAB */}
        {tab === "payments" && (
  <div>
    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16}}>
      <h3 style={{margin: 0, fontSize: 16, fontWeight: 600}}>Payment History</h3>
      <button onClick={() => setShowAddPayment(true)} style={primaryBtn("#059669", "#fff", {fontSize: 13})}>+ Record payment</button>
    </div>
    <div style={{background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 12, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#92400E"}}>
      ⚠️ <strong>No Refund Policy:</strong> All payments recorded here are strictly non-refundable once processed.
    </div>
    <div style={{display: "flex", flexDirection: "column", gap: 10}}>
      {payments.length === 0 && <div style={{textAlign: "center", padding: 40, color: C.muted}}>No payments recorded yet.</div>}
      {[...payments]
        .filter(pay => pay)  // remove any undefined entries
        .reverse()
        .map(pay => {
          // safe fallbacks for any missing fields
          const amount = pay?.amount ?? 0;
          const mode = pay?.mode ?? "—";
          const receiptNo = pay?.receiptNo ?? "N/A";
          const date = pay?.date;
          const note = pay?.note;
          return (
            <div key={pay.id || genId()} style={{background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px 20px", display: "flex", alignItems: "center", gap: 16}}>
              <div style={{width: 44, height: 44, borderRadius: 12, background: "#ECFDF5", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0}}>🧾</div>
              <div style={{flex: 1}}>
                <div style={{fontWeight: 600, fontSize: 14}}>₹{amount.toLocaleString("en-IN")} <span style={{color: C.muted, fontWeight: 400, fontSize: 13}}>· {mode}</span></div>
                <div style={{fontSize: 12, color: C.muted, marginTop: 2}}>{receiptNo} · {fmtDate(date)}{note && ` · ${note}`}</div>
              </div>
              <button onClick={() => setShowReceipt(pay)} style={primaryBtn("#4F46E5", "#fff", {fontSize: 12, padding: "7px 16px"})}>🖨️ Receipt</button>
            </div>
          );
        })}
      <div style={{background: C.surface, borderRadius: 12, padding: "14px 20px", display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 600}}>
        <span>Total paid: ₹{(project?.advancePaid || 0).toLocaleString("en-IN")}</span>
        <span style={{color: (project?.totalBudget || 0) - (project?.advancePaid || 0) > 0 ? "#D97706" : "#059669"}}>
          {(project?.totalBudget || 0) - (project?.advancePaid || 0) > 0
            ? `Due: ₹${((project?.totalBudget || 0) - (project?.advancePaid || 0)).toLocaleString("en-IN")}`
            : "✅ Fully paid"}
        </span>
      </div>
    </div>
  </div>
)}

        {/* INFO TAB */}
        {tab === "info" && (
          <Card>
            <div style={{display: "flex", justifyContent: "space-between", marginBottom: 16}}>
              <h3 style={{margin: 0, fontWeight: 600, fontSize: 16}}>Project information</h3>
              {!editInfo && <button onClick={() => {setInfoForm({...project}); setEditInfo(true);}} style={primaryBtn("#4F46E5", "#fff", {fontSize: 13, padding: "7px 16px"})}>Edit</button>}
            </div>
            {editInfo ? (
              <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14}}>
                {[["studentName", "Student name", "text"], ["email", "Email", "email"], ["phone", "Phone", "tel"], ["college", "College", "text"]].map(([k, label, type]) => (
                  <div key={k}><label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>{label}</label>
                    <input type={type} value={infoForm[k] || ""} onChange={e => setInfoForm(f => ({...f, [k]: e.target.value}))} style={inputStyle({margin: 0})}/></div>
                ))}
                <div style={{gridColumn: "1/-1"}}><label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Project title</label>
                  <input value={infoForm.title || ""} onChange={e => setInfoForm(f => ({...f, title: e.target.value}))} style={inputStyle({margin: 0})}/></div>
                {[["domain", "Domain", DOMAINS], ["staff", "Staff", STAFF_LIST], ["status", "Status", STATUSES]].map(([k, label, opts]) => (
                  <div key={k}><label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>{label}</label>
                    <select value={infoForm[k] || ""} onChange={e => setInfoForm(f => ({...f, [k]: e.target.value}))} style={inputStyle({margin: 0})}>{opts.map(o => <option key={o}>{o}</option>)}</select></div>
                ))}
                {/* Total Budget – editable only if not yet set */}
            {/* ── Total Budget (lock based on the original project value) ── */}
              {(() => {
                const isBudgetLocked = (project?.totalBudget || 0) > 0;
                 return (
                  <div>
                   <label style={{ fontSize: 12, color: C.muted, display: "block", marginBottom: 5 }}>
                     Total budget (₹) {isBudgetLocked && "🔒"}
                   </label>
                 {isBudgetLocked ? (
        <div style={{
          ...inputStyle({ margin: 0 }),
          background: C.surface,
          color: C.muted,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <span>₹{project.totalBudget.toLocaleString("en-IN")}</span>
          <span style={{
            fontSize: 11,
            background: "#FEF2F2",
            color: "#991B1B",
            padding: "2px 8px",
            borderRadius: 99
          }}>
            Locked
          </span>
        </div>
      ) : (
        <input
          type="number"
          value={infoForm.totalBudget || ""}
          onChange={e => setInfoForm(f => ({...f, totalBudget: e.target.value}))}
          placeholder="Enter total project cost"
          style={inputStyle({ margin: 0 })}
        />
      )}
      <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
        {isBudgetLocked
          ? "Total budget has been locked and cannot be changed."
          : "Set the total budget – this value will be locked after saving."}
      </div>
    </div>
  );
})()}

{/* ── Advance Paid – always editable ── */}
<div>
  <label style={{ fontSize: 12, color: C.muted, display: "block", marginBottom: 5 }}>
    Advance paid (₹)
  </label>
  <input
    type="number"
    value={infoForm.advancePaid || ""}
    onChange={e => setInfoForm(f => ({...f, advancePaid: e.target.value}))}
    style={inputStyle({ margin: 0 })}
  />
</div>
{/* ── DEADLINE ── */}
<div>
  <label style={{ fontSize: 12, color: C.muted, display: "block", marginBottom: 5 }}>
    Deadline / Submission Date
  </label>
  <input
    type="date"
    value={infoForm.deadline || ""}
    onChange={e => setInfoForm(f => ({...f, deadline: e.target.value}))}
    style={inputStyle({ margin: 0 })}
  />
</div>

{/* ── PROJECT SCOPE ── */}
<div style={{ gridColumn: "1/-1" }}>
  <label style={{ fontSize: 12, color: C.muted, display: "block", marginBottom: 5 }}>
    Project Scope / Description
  </label>
  <textarea
    value={infoForm.projectScope || ""}
    onChange={e => setInfoForm(f => ({...f, projectScope: e.target.value}))}
    rows={4}
    placeholder="Detailed scope of the project..."
    style={{ ...inputStyle({ margin: 0 }), resize: "vertical" }}
  />
</div>

{/* Advance Paid – remains editable */}
<div>
  <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Advance paid (₹)</label>
  <input type="number" value={infoForm.advancePaid || ""} onChange={e => setInfoForm(f => ({...f, advancePaid: e.target.value}))} style={inputStyle({margin: 0})}/>
</div>
                <div style={{gridColumn: "1/-1"}}><label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Notes</label>
                  <textarea value={infoForm.notes || ""} onChange={e => setInfoForm(f => ({...f, notes: e.target.value}))} rows={3} style={{...inputStyle({margin: 0}), resize: "vertical"}}/></div>
                <div style={{gridColumn: "1/-1", display: "flex", gap: 10, justifyContent: "flex-end"}}>
                  <button onClick={() => setEditInfo(false)} style={ghostBtn()}>Cancel</button>
                  <button onClick={saveInfo} style={primaryBtn("#4F46E5", "#fff")}>Save changes</button>
                </div>
              </div>
            ) : (
              <div>
                {[
                  ["Student", project?.studentName],
                  ["Email", project?.email],
                  ["Phone", project?.phone],
                  ["College", project?.college],
                  ["Domain", project?.domain],
                  ["Project title", project?.title],
                  ["Assigned staff", project?.staff],
                  ["Deadline", project?.deadline ? fmtDate(project.deadline) : "—"],
["Project Scope", project?.projectScope || "—"],
                  ["Total budget", 
  <span>
    ₹{(project?.totalBudget || 0).toLocaleString("en-IN")}
    {(project?.totalBudget || 0) > 0 && <span style={{marginLeft: 8, fontSize: 10, color: "#991B1B", background: "#FEF2F2", padding: "2px 8px", borderRadius: 99}}>locked</span>}
  </span>
],
                  ["Collected", `₹${(project?.advancePaid || 0).toLocaleString("en-IN")}`],
                  ["Balance", `₹${((project?.totalBudget || 0) - (project?.advancePaid || 0)).toLocaleString("en-IN")}`],
                  ["Status", null],
                  ["Portal ID", project?.id],
                  ["Portal PIN", project?.portalPin],
                  ["Registered", fmtDate(project?.createdAt)],
                  ...(project?.notes ? [["Notes", project.notes]] : [])
                ].map(([k, v]) => (
                  <div key={k} style={{display: "flex", padding: "9px 0", borderBottom: `1px solid ${C.border}`, fontSize: 14}}>
                    <span style={{color: C.muted, minWidth: 140, flexShrink: 0}}>{k}</span>
                    {k === "Status" ? <Badge status={project?.status}>{project?.status}</Badge> :
                     k === "Portal PIN" ? <span style={{fontFamily: "monospace", fontWeight: 700, fontSize: 16, letterSpacing: 4, color: C.indigo}}>{v}</span> :
                     <span style={{flex: 1}}>{v}</span>}
                  </div>
                ))}
              </div>
            )}
            <div style={{ marginTop: 24, borderTop: `1px solid ${C.border}`, paddingTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
  <button
    onClick={() => setShowProcessPDF(true)}
    style={primaryBtn("#4F46E5", "#fff", { fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 })}
  >
    📄 Download Development Process (PDF)
  </button>
</div>
          </Card>
        )}
      </div>

      {/* ADD CONTENT MODAL */}
      {showAddContent && (
        <StyledModal onClose={() => setShowAddContent(false)} title={`Send content to ${project.studentName}`} maxWidth={620}>
          <div style={{marginBottom: 14}}>
            <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 8, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em"}}>Content type</label>
            <div style={{display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 8}}>
              {CONTENT_TYPES.map(ct => (
                <button key={ct.id} onClick={() => setNewBlock(b => ({...b, type: ct.id}))}
                  style={{padding: "8px 4px", borderRadius: 10, border: `2px solid ${newBlock.type === ct.id ? ct.color : C.border}`, background: newBlock.type === ct.id ? ct.bg : "transparent", cursor: "pointer", textAlign: "center"}}>
                  <div style={{fontSize: 18, marginBottom: 3}}>{ct.icon}</div>
                  <div style={{fontSize: 10, fontWeight: 600, color: newBlock.type === ct.id ? ct.color : C.muted}}>{ct.label}</div>
                </button>
              ))}
            </div>
          </div>
          <div style={{marginBottom: 12}}>
            <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5, fontWeight: 600}}>Title</label>
            <input value={newBlock.title} onChange={e => setNewBlock(b => ({...b, title: e.target.value}))} placeholder="e.g. System Block Diagram" style={inputStyle({margin: 0})}/>
          </div>
          <div style={{marginBottom: 16}}>
            <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5, fontWeight: 600}}>Content</label>
            <textarea value={newBlock.body} onChange={e => setNewBlock(b => ({...b, body: e.target.value}))} rows={8} placeholder="Paste abstract, block diagram, code, synopsis..." style={{...inputStyle({margin: 0}), resize: "vertical", fontFamily: newBlock.type === "code" ? "monospace" : "inherit"}}/>
          </div>
          <div style={{display: "flex", gap: 10, justifyContent: "flex-end"}}>
            <button onClick={() => setShowAddContent(false)} style={ghostBtn()}>Cancel</button>
            <button onClick={sendContent} style={primaryBtn("#4F46E5", "#fff")}>Send to student →</button>
          </div>
        </StyledModal>
      )}

      {/* ADD CONTACT MODAL */}
      {showAddContact && (
        <StyledModal onClose={() => setShowAddContact(false)} title="Add contact to project" maxWidth={480}>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Full name *</label>
          <input value={newContact.name} onChange={e => setNewContact(c => ({...c, name: e.target.value}))} placeholder="Contact's full name" style={inputStyle()}/>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Email *</label>
          <input type="email" value={newContact.email} onChange={e => setNewContact(c => ({...c, email: e.target.value}))} placeholder="email@example.com" style={inputStyle()}/>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Phone *</label>
          <input type="tel" value={newContact.phone} onChange={e => setNewContact(c => ({...c, phone: e.target.value}))} placeholder="10-digit mobile number" style={inputStyle()}/>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Role</label>
          <select value={newContact.role} onChange={e => setNewContact(c => ({...c, role: e.target.value}))} style={inputStyle()}>
            {["Student", "Guardian", "Parent", "Colleague", "Co-author", "Other"].map(r => <option key={r}>{r}</option>)}
          </select>
          <div style={{background: "#EFF6FF", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#1D4ED8", marginBottom: 16}}>
            ℹ️ This contact's email and phone will be visible in the project's contact list.
          </div>
          <div style={{display: "flex", gap: 10, justifyContent: "flex-end"}}>
            <button onClick={() => setShowAddContact(false)} style={ghostBtn()}>Cancel</button>
            <button onClick={addContact} style={primaryBtn("#4F46E5", "#fff")}>Add contact</button>
          </div>
        </StyledModal>
      )}

      {/* ADD PAYMENT MODAL */}
      {showAddPayment && (
        <StyledModal onClose={() => setShowAddPayment(false)} title="Record payment" maxWidth={480}>
          <div style={{background: "#EEF2FF", borderRadius: 12, padding: "12px 16px", marginBottom: 16, fontSize: 13}}>
            <div style={{display: "flex", justifyContent: "space-between", marginBottom: 4}}><span style={{color: "#4338CA"}}>Total budget</span><span style={{fontWeight: 700}}>₹{project.totalBudget.toLocaleString("en-IN")}</span></div>
            <div style={{display: "flex", justifyContent: "space-between", marginBottom: 4}}><span style={{color: "#4338CA"}}>Collected</span><span style={{fontWeight: 700, color: "#059669"}}>₹{project.advancePaid.toLocaleString("en-IN")}</span></div>
            <div style={{display: "flex", justifyContent: "space-between"}}><span style={{color: "#4338CA"}}>Outstanding</span><span style={{fontWeight: 700, color: pending > 0 ? "#D97706" : "#059669"}}>₹{pending.toLocaleString("en-IN")}</span></div>
          </div>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Amount received (₹) *</label>
          <input type="number" value={newPayment.amount} onChange={e => setNewPayment(p => ({...p, amount: e.target.value}))} placeholder={`Max ₹${pending.toLocaleString("en-IN")}`} style={inputStyle()}/>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Payment mode</label>
          <select value={newPayment.mode} onChange={e => setNewPayment(p => ({...p, mode: e.target.value}))} style={inputStyle()}>
            <option>Online</option><option>Cash</option><option>Cheque</option><option>UPI</option>
          </select>
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 5}}>Narration / note</label>
          <input value={newPayment.note} onChange={e => setNewPayment(p => ({...p, note: e.target.value}))} placeholder="e.g. Second instalment, final payment..." style={inputStyle()}/>
          <div style={{background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#7F1D1D", marginBottom: 16}}>
            ⚠️ <strong>No Refund:</strong> Recording this payment confirms it is non-refundable. A receipt will be generated automatically.
          </div>
          <div style={{display: "flex", gap: 10, justifyContent: "flex-end"}}>
            <button onClick={() => setShowAddPayment(false)} style={ghostBtn()}>Cancel</button>
            <button onClick={addPayment} style={primaryBtn("#059669", "#fff")}>Record & generate receipt</button>
          </div>
        </StyledModal>
      )}
      {showProcessPDF && (
  <ProjectDevelopmentProcessPDF
    project={project}
    onClose={() => setShowProcessPDF(false)}
  />
)}
    </div>
  );
}
// ─── STYLED MODAL WRAPPER ────────────────────────────────────────────────────
// function StyledModal({onClose,title,maxWidth=520,children}){
//   return (
//     <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(4px)"}}>
//       <div onClick={e=>e.stopPropagation()} style={{background:C.card,borderRadius:20,maxWidth,width:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 24px 64px rgba(0,0,0,0.3)"}}>
//         <div style={{padding:"20px 24px 0",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
//           <h3 style={{margin:0,fontSize:17,fontWeight:700}}>{title}</h3>
//           <button onClick={onClose} style={{width:32,height:32,borderRadius:8,border:"none",background:C.surface,cursor:"pointer",fontSize:16,color:C.muted,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
//         </div>
//         <div style={{padding:"0 24px 24px"}}>{children}</div>
//       </div>
//     </div>
//   );
// }

function ProjectDevelopmentProcessPDF({ project, onClose }) {
  const iframeRef = useRef();

  // Primary contact
  const primaryContact = project?.contacts?.find(c => c.role === "Student") || project?.contacts?.[0] || {};

  // Advance payment – take first payment record
  const advancePayment = project?.payments?.[0] || null;
  const advanceAmt = advancePayment?.amount || project?.advancePaid || 0;
  const totalCost = project?.totalBudget || 0;
  const remaining = Math.max(totalCost - advanceAmt, 0);

  // Academic session, e.g. "2026 - 2027"
  const now = new Date();
  const sessionYear = project?.session || `${now.getFullYear()} - ${now.getFullYear() + 1}`;

  const getProcessHTML = () => `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Project Development Process - ${project.id}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }

  :root {
    --ink: #12172B;
    --slate: #5B6478;
    --faint: #94A0B4;
    --line: #B9C0CE;
    --paper: #FFFFFF;
    --accent: #3730A3;
    --accent-tint: #EEF2FF;
    --notice-tint: #FFFBEB;
    --notice-line: #F0D8A0;
    --notice: #92400E;
  }

  @page { size: A4; margin: 0; }

  html, body {
    font-family: 'Inter', Arial, sans-serif;
    background: #E7E9EE;
    color: var(--ink);
    -webkit-print-color-adjust: exact; print-color-adjust: exact;
  }

  /* A4 = 210mm x 297mm */
  .sheet {
    width: 210mm;
    min-height: 297mm;
    margin: 0 auto;
    background: var(--paper);
    padding: 12mm 13mm 10mm;
    position: relative;
  }

  /* ---------- Letterhead ---------- */
  .letterhead {
    display: flex; justify-content: space-between; align-items: flex-start;
    border-bottom: 2px solid var(--ink);
    padding-bottom: 10px; margin-bottom: 12px;
  }
  .co-block { display: flex; align-items: center; gap: 12px; }
  .seal { width: 42px; height: 42px; flex-shrink: 0; }
  .co-name { font-family: 'Source Serif 4', serif; font-size: 16px; font-weight: 700; color: var(--ink); line-height: 1.2; }
  .co-tag { font-size: 9.5px; color: var(--slate); margin-top: 2px; font-style: italic; }
  .co-contact { font-size: 8.5px; color: var(--faint); margin-top: 4px; line-height: 1.5; }
  .session-badge {
    font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600;
    color: var(--accent); background: var(--accent-tint); border: 1px solid #C7D2FE;
    padding: 5px 10px; white-space: nowrap; align-self: flex-start;
  }

  /* ---------- Title ---------- */
  .title-row { text-align: center; margin-bottom: 14px; }
  .page-title {
    font-family: 'Source Serif 4', serif; font-size: 19px; font-weight: 700; color: var(--ink);
    letter-spacing: 0.01em;
  }
  .page-subtitle { font-size: 9.5px; color: var(--slate); margin-top: 2px; letter-spacing: 0.04em; }

  /* ---------- Date row ---------- */
  .date-row { display: flex; gap: 24px; margin-bottom: 12px; }
  .date-field { flex: 1; display: flex; align-items: baseline; gap: 8px; }
  .date-field .k { font-size: 10px; font-weight: 600; color: var(--ink); white-space: nowrap; }
  .date-field .fill { flex: 1; border-bottom: 1px solid var(--line); font-size: 11px; color: var(--ink); padding-bottom: 3px; min-height: 15px; }

  /* ---------- Form table ---------- */
  table.form { width: 100%; border-collapse: collapse; margin-bottom: 0; }
  table.form td {
    border: 1px solid var(--line); padding: 8px 12px; vertical-align: top; font-size: 11.5px;
  }
  .label-cell {
    background: #F5F6F9; width: 32%;
    font-size: 9.5px; font-weight: 700; color: var(--ink);
    text-transform: uppercase; letter-spacing: 0.06em;
  }
  .value-cell { color: var(--ink); font-size: 12px; font-weight: 500; }
  .scope-cell { min-height: 90px; line-height: 1.7; white-space: pre-wrap; }
  .sub-k { font-family: 'JetBrains Mono', monospace; font-size: 8px; color: var(--faint); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 2px; }
  .sub-v { font-size: 11.5px; font-weight: 600; color: var(--ink); margin-bottom: 6px; }

  /* Money row */
  .money-label-cell { font-size: 10px; font-weight: 700; color: var(--ink); text-transform: uppercase; letter-spacing: 0.06em; }
  .money-value-cell { font-family: 'JetBrains Mono', monospace; font-size: 14px; font-weight: 600; color: var(--ink); text-align: right; }
  tr.total-row .money-label-cell,
  tr.total-row .money-value-cell { background: var(--accent-tint); color: var(--accent); font-weight: 700; }
  tr.total-row .money-value-cell { font-size: 15px; }

  /* Signature row */
  .sig-cell { height: 46px; }
  .sig-cell .k { font-size: 9.5px; font-weight: 700; color: var(--ink); text-transform: uppercase; letter-spacing: 0.06em; display:block; margin-bottom: 18px; }
  .sig-cell .line { border-top: 1px solid var(--ink); width: 80%; }

  /* ---------- Terms ---------- */
  .terms { margin-top: 12px; background: var(--notice-tint); border: 1px solid var(--notice-line); border-left: 3px solid var(--notice); padding: 10px 14px; }
  .terms .lbl { font-family: 'JetBrains Mono', monospace; font-size: 8.5px; font-weight: 700; color: var(--notice); text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 5px; }
  .terms p { font-size: 9.5px; line-height: 1.65; color: #78350F; }

  /* ---------- Footer ---------- */
  .footer { position: absolute; bottom: 8mm; left: 13mm; right: 13mm; display: flex; justify-content: space-between; border-top: 1px solid var(--line); padding-top: 6px; }
  .footer span { font-size: 8px; color: var(--faint); }
  .footer .ref { font-family: 'JetBrains Mono', monospace; }

  @media print {
    body { background: #fff; }
    .sheet { box-shadow: none; }
  }
</style>
</head>
<body>
<div class="sheet">

  <!-- Letterhead -->
  <div class="letterhead">
    <div class="co-block">
      <svg class="seal" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="47" fill="none" stroke="#3730A3" stroke-width="2"/>
        <circle cx="50" cy="50" r="39" fill="none" stroke="#3730A3" stroke-width="1"/>
        <circle cx="50" cy="50" r="30" fill="#3730A3"/>
        <text x="50" y="58" font-family="'Source Serif 4', serif" font-size="24" font-weight="700" fill="#fff" text-anchor="middle">${(COMPANY.name || "K").trim().charAt(0)}</text>
      </svg>
      <div>
        <div class="co-name">${COMPANY.name}</div>
        <div class="co-tag">${COMPANY.tagline}</div>
        <div class="co-contact">
          ${COMPANY.address}<br/>
          ${COMPANY.phone} &nbsp;·&nbsp; ${COMPANY.email}
        </div>
      </div>
    </div>
    <div class="session-badge">Session ${sessionYear}</div>
  </div>

  <!-- Title -->
  <div class="title-row">
    <div class="page-title">Project Development Process</div>
    <div class="page-subtitle">Engineering Project Consultancy — A Company by Karolina Enterprises</div>
  </div>

  <!-- Dates -->
  <div class="date-row">
    <div class="date-field">
      <div class="k">Date:</div>
      <div class="fill">${fmtDate(new Date())}</div>
    </div>
    <div class="date-field">
      <div class="k">Date of Submission:</div>
      <div class="fill">${project?.deadline ? fmtDate(project.deadline) : ""}</div>
    </div>
  </div>

  <!-- Main form table -->
  <table class="form">
    <tr>
      <td class="label-cell">Project Title</td>
      <td class="value-cell">${project?.title || "—"}</td>
    </tr>
    <tr>
      <td class="label-cell">Project Total Cost</td>
      <td class="value-cell">₹${totalCost.toLocaleString("en-IN")}</td>
    </tr>
    <tr>
      <td class="label-cell">Candidate Details</td>
      <td class="value-cell">
        <div class="sub-k">Name</div><div class="sub-v">${primaryContact.name || project?.studentName || "—"}</div>
        <div class="sub-k">College</div><div class="sub-v">${project?.college || "—"}</div>
        <div class="sub-k">Email</div><div class="sub-v">${primaryContact.email || project?.email || "—"}</div>
        <div class="sub-k" style="margin-bottom:0;">Phone</div><div class="sub-v" style="margin-bottom:0;">${primaryContact.phone || project?.phone || "—"}</div>
      </td>
    </tr>
    <tr>
      <td class="label-cell">Project Scope / Description</td>
      <td class="value-cell scope-cell">${(project?.projectScope || "No scope defined yet.").replace(/\n/g, "<br/>")}</td>
    </tr>
  </table>

  <!-- Money table -->
  <table class="form">
    <tr>
      <td class="label-cell money-label-cell">Advance</td>
      <td class="value-cell money-value-cell">₹${advanceAmt.toLocaleString("en-IN")}</td>
    </tr>
    <tr>
      <td class="label-cell money-label-cell">Remaining</td>
      <td class="value-cell money-value-cell">₹${remaining.toLocaleString("en-IN")}</td>
    </tr>
    <tr class="total-row">
      <td class="label-cell money-label-cell">Total Cost</td>
      <td class="value-cell money-value-cell">₹${totalCost.toLocaleString("en-IN")}</td>
    </tr>
  </table>

  <!-- Date / Signature row -->
  <table class="form">
    <tr>
      <td class="sig-cell" style="width:50%;">
        <span class="k">Date</span>
        <div class="line"></div>
      </td>
      <td class="sig-cell" style="width:50%;">
        <span class="k">Signature</span>
        <div class="line"></div>
      </td>
    </tr>
  </table>

  <!-- Terms -->
  <div class="terms">
    <div class="lbl">Terms &amp; Conditions</div>
    <p>
      Scope change will make changes in your base price. Advance will be non-refundable after confirmation
      and start of project. After handover, the project cannot be returned or exchanged for money.
    </p>
  </div>

  <div class="footer">
    <span>${COMPANY.name} &nbsp;·&nbsp; ${COMPANY.address}</span>
    <span class="ref">PDP-${String(project?.id || "0000").toUpperCase()}</span>
  </div>

</div>
</body>
</html>`;

  const handlePrint = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const iframeWin = iframe.contentWindow || iframe.contentDocument?.defaultView;
    if (iframeWin) {
      iframeWin.focus();
      iframeWin.print();
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(getProcessHTML());
      doc.close();
    }
    // Auto-trigger print after a tiny delay to ensure rendering
    setTimeout(handlePrint, 300);
  }, []);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(15,17,26,0.65)", zIndex: 200,
        display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
        backdropFilter: "blur(4px)"
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#EEF0F4", borderRadius: 16, maxWidth: 820, width: "100%",
          maxHeight: "92vh", display: "flex", flexDirection: "column",
          boxShadow: "0 32px 80px rgba(0,0,0,0.45)", overflow: "hidden"
        }}
      >
        {/* Modal header */}
        <div style={{
          padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center",
          background: "#12172B", flexShrink: 0
        }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#fff", letterSpacing: "0.01em" }}>
              Project Development Process
            </div>
            <div style={{ fontSize: 11, color: "#94A0B4", marginTop: 2 }}>
              A4 document preview &nbsp;·&nbsp; {project?.title || "Untitled project"}
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              width: 30, height: 30, borderRadius: 8, border: "1px solid #2C3350",
              background: "transparent", color: "#94A0B4", fontSize: 15, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center"
            }}
          >
            ✕
          </button>
        </div>

        {/* Document preview */}
        <div style={{ overflowY: "auto", padding: "24px", flex: 1, display: "flex", justifyContent: "center" }}>
          <div
            dangerouslySetInnerHTML={{ __html: getProcessHTML() }}
            style={{ boxShadow: "0 1px 3px rgba(18,23,43,0.12)", transform: "scale(0.85)", transformOrigin: "top center" }}
          />
        </div>

        {/* Action bar */}
        <div style={{
          padding: "14px 24px", display: "flex", gap: 10, justifyContent: "flex-end",
          background: "#fff", borderTop: "1px solid #E2E8F0", flexShrink: 0
        }}>
          <button onClick={onClose} style={ghostBtn()}>Close</button>
          <button
            onClick={handlePrint}
            style={primaryBtn("#3730A3", "#fff", { fontSize: 14, fontWeight: 700, padding: "10px 24px" })}
          >
            Print / Save as PDF
          </button>
        </div>
      </div>

      <iframe
        ref={iframeRef}
        title="process-print"
        style={{ position: "absolute", left: "-9999px", top: "-9999px", width: "800px", height: "1100px", border: "none", opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
}

function StyledModal({onClose,title,maxWidth=520,children}){
  return (
    // Transparent backdrop
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.3)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(2px)"}}>
      {/* Solid colored box */}
      <div onClick={e=>e.stopPropagation()} style={{
        background:"linear-gradient(135deg, #4F46E5, #7C3AED)", // Purple gradient
        borderRadius:24,
        maxWidth,
        width:"100%",
        maxHeight:"90vh",
        overflowY:"auto",
        boxShadow:"0 24px 64px rgba(0,0,0,0.4)",
        padding:"24px",
        color:"#fff"
      }}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h3 style={{margin:0,fontSize:18,fontWeight:700,color:"#fff"}}>{title}</h3>
          <button onClick={onClose} style={{
            width:32,
            height:32,
            borderRadius:8,
            border:"none",
            background:"rgba(255,255,255,0.2)",
            cursor:"pointer",
            fontSize:18,
            color:"#fff",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
          }}>×</button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}

// ─── STUDENT DASHBOARD ────────────────────────────────────────────────────────
function StudentDashboard({project,setView,tab,setTab}) {
  // Add safe fallbacks at the very beginning
  const safeProject = project || {};
  const blocks = [...(safeProject.contentBlocks || [])].sort((a,b) => new Date(b.sentAt) - new Date(a.sentAt));
  const done = blocks.filter(b => b?.readAt).length;
  const pct = blocks.length ? Math.round((done/blocks.length)*100) : 0;
  
  // SAFE: Use nullish coalescing and optional chaining
  const totalBudget = safeProject.totalBudget ?? 0;
  const advancePaid = safeProject.advancePaid ?? 0;
  const pending = totalBudget - advancePaid;
  const payments = safeProject.payments || [];
  const [showReceipt,setShowReceipt] = useState(null);

  const TABS_ORDERED = ["timeline","payments","synopsis","ppt"];
  const relevant = {
    synopsis: blocks.filter(b => ["abstract","intro","synopsis","result","reference"].includes(b?.type)),
    ppt: blocks.filter(b => ["abstract","block_diagram","flowchart","result","ppt"].includes(b?.type)),
  };

  // If project is null/undefined, show a loading state
  if (!project || Object.keys(project).length === 0) {
    return (
      <div style={{minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#0B1220"}}>
        <div style={{textAlign:"center", color:"#fff"}}>
          <div style={{fontSize:40, marginBottom:16}}>📁</div>
          <div style={{fontSize:18, fontWeight:600}}>Loading project data...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#0B1220 0%,#0f1a2e 60%,#0a1628 100%)"}}>
      {showReceipt&&<ReceiptModal project={safeProject} payment={showReceipt} onClose={()=>setShowReceipt(null)}/>}
      <div style={{padding:"14px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:32,height:32,borderRadius:8,background:"linear-gradient(135deg,#10B981,#34D399)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>🎓</div>
          <div>
            <div style={{color:"#fff",fontWeight:700,fontSize:14}}>My Project Portal</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:11}}>{COMPANY.name}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {TABS_ORDERED.map(t=>(
            <button key={t} onClick={()=>setTab(t)} style={{padding:"7px 14px",border:"none",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:600,
              background:tab===t?"rgba(16,185,129,0.2)":"transparent",
              color:tab===t?"#34D399":"rgba(255,255,255,0.4)",textTransform:"capitalize"}}>
              {t==="ppt"?"PPT Guide":t==="synopsis"?"Synopsis":t==="payments"?"My Payments":t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
          ))}
          <button onClick={()=>setView("home")} style={{padding:"7px 14px",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,background:"transparent",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:12}}>Sign out</button>
        </div>
      </div>

      <div style={{maxWidth:900,margin:"0 auto",padding:"24px 20px"}}>
        <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:20,padding:"24px 28px",marginBottom:20,display:"flex",gap:20,alignItems:"center"}}>
          <Avatar name={safeProject.studentName || "Student"} size={56} bg="rgba(79,70,229,0.25)" color="#818CF8"/>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.5)",fontSize:12,marginBottom:4}}>Welcome back</div>
            <div style={{color:"#fff",fontWeight:700,fontSize:22}}>{safeProject.studentName || "Student"}</div>
            <div style={{color:"rgba(255,255,255,0.5)",fontSize:13}}>{safeProject.title || "No title"}</div>
            <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap"}}>
              <span style={{background:"rgba(79,70,229,0.2)",color:"#818CF8",fontSize:11,padding:"3px 10px",borderRadius:99,fontWeight:600}}>{safeProject.domain || "—"}</span>
              <span style={{background:"rgba(255,255,255,0.07)",color:"rgba(255,255,255,0.5)",fontSize:11,padding:"3px 10px",borderRadius:99}}>{safeProject.college || "—"}</span>
              <span style={{background:pending>0?"rgba(245,158,11,0.15)":"rgba(16,185,129,0.15)",color:pending>0?"#F59E0B":"#10B981",fontSize:11,padding:"3px 10px",borderRadius:99,fontWeight:600}}>
                {pending>0?`₹${pending.toLocaleString("en-IN")} balance due`:"Fully paid ✓"}
              </span>
            </div>
          </div>
          <div style={{textAlign:"right",flexShrink:0}}>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginBottom:6}}>Content received</div>
            <div style={{fontSize:36,fontWeight:800,color:pct===100?"#10B981":"#818CF8",lineHeight:1}}>{pct}%</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.4)"}}>({done}/{blocks.length} blocks)</div>
          </div>
        </div>

        {tab==="timeline"&&(
          <div>
            <h3 style={{color:"#fff",fontSize:16,fontWeight:700,margin:"0 0 16px"}}>Content timeline</h3>
            {blocks.length===0&&<div style={{textAlign:"center",padding:"60px 20px",color:"rgba(255,255,255,0.3)"}}>
              <div style={{fontSize:48,marginBottom:12}}>📭</div>
              <div style={{fontSize:16,fontWeight:500,color:"rgba(255,255,255,0.5)"}}>No content yet — your team will start sending updates soon!</div>
            </div>}
            <div style={{position:"relative"}}>
              {blocks.length>0&&<div style={{position:"absolute",left:20,top:0,bottom:0,width:2,background:"rgba(255,255,255,0.06)"}}/>}
              {blocks.map(block=>{
                const ctType=CONTENT_TYPES.find(c=>c.id===block.type)||CONTENT_TYPES[0];
                return <div key={block.id} style={{paddingLeft:52,marginBottom:20,position:"relative"}}>
                  <div style={{position:"absolute",left:10,top:4,width:22,height:22,borderRadius:"50%",background:ctType.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,border:"3px solid #0B1220",zIndex:1}}>
                    <span>{ctType.icon}</span>
                  </div>
                  <div style={{background:"rgba(255,255,255,0.04)",border:`1px solid ${!block.readAt?"rgba(245,158,11,0.4)":"rgba(255,255,255,0.06)"}`,borderRadius:14,padding:"16px 18px"}}>
                    <div style={{color:"#fff",fontWeight:700,fontSize:15,marginBottom:6}}>{block.title}</div>
                    <div style={{background:"rgba(0,0,0,0.3)",borderRadius:10,padding:"12px 14px",fontSize:13,color:"rgba(255,255,255,0.75)",lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:block.type==="code"?"monospace":"inherit",maxHeight:200,overflowY:"auto"}}>
                      {block.body}
                    </div>
                    <div style={{marginTop:10,fontSize:11,color:block.readAt?"#10B981":"#F59E0B",fontWeight:600}}>
                      {block.readAt?`✓ Read on ${fmtDate(block.readAt)}`:"● New content"}
                    </div>
                  </div>
                </div>;
              })}
            </div>
          </div>
        )}

        {tab==="payments"&&(
          <div>
            <h3 style={{color:"#fff",fontSize:16,fontWeight:700,margin:"0 0 8px"}}>My Payments</h3>
            <div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:12,padding:"12px 16px",marginBottom:16,fontSize:13,color:"#FCA5A5"}}>
              ⚠️ <strong>No Refund Policy:</strong> All payments made are strictly non-refundable once processed.
            </div>
            <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"16px 20px",marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"rgba(255,255,255,0.5)",marginBottom:8}}><span>Total Budget</span><span style={{color:"#fff",fontWeight:600}}>₹{totalBudget.toLocaleString("en-IN")}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"rgba(255,255,255,0.5)",marginBottom:8}}><span>Total Paid</span><span style={{color:"#10B981",fontWeight:600}}>₹{advancePaid.toLocaleString("en-IN")}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:14,fontWeight:700,borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:8}}><span style={{color:"rgba(255,255,255,0.7)"}}>Balance</span><span style={{color:pending>0?"#F59E0B":"#10B981"}}>{pending>0?`₹${pending.toLocaleString("en-IN")} due`:"✅ Fully Paid"}</span></div>
            </div>
            {payments.length===0&&<div style={{textAlign:"center",padding:40,color:"rgba(255,255,255,0.3)"}}>No payment records yet.</div>}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {[...payments].reverse().map(pay=>(
                <div key={pay.id} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"14px 18px",display:"flex",alignItems:"center",gap:14}}>
                  <div style={{fontSize:24,flexShrink:0}}>🧾</div>
                  <div style={{flex:1}}>
                    <div style={{color:"#fff",fontWeight:600,fontSize:14}}>₹{(pay?.amount || 0).toLocaleString("en-IN")} <span style={{color:"rgba(255,255,255,0.4)",fontWeight:400,fontSize:13}}>· {pay?.mode || "—"}</span></div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,marginTop:2}}>{pay?.receiptNo || "N/A"} · {fmtDate(pay?.date)}{pay?.note&&` · ${pay.note}`}</div>
                  </div>
                  <button onClick={()=>setShowReceipt(pay)} style={primaryBtn("#4F46E5","#fff",{fontSize:12,padding:"7px 14px"})}>🖨️ Receipt</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {(tab==="synopsis"||tab==="ppt")&&(
          <div>
            <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:"14px 18px",marginBottom:18}}>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:13,lineHeight:1.7}}>
                {tab==="synopsis"&&"All content relevant to writing your synopsis — use the abstract as your intro, then expand each section."}
                {tab==="ppt"&&"Presentation-ready content — start with the abstract, use the block diagram for architecture, then walk through results."}
              </div>
            </div>
            {relevant[tab].length===0&&<div style={{textAlign:"center",padding:"40px",color:"rgba(255,255,255,0.3)",fontSize:14}}>No relevant content blocks yet.</div>}
            {relevant[tab].map(block=>{
              const ctType=CONTENT_TYPES.find(c=>c.id===block.type)||CONTENT_TYPES[0];
              return <div key={block.id} style={{marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <span>{ctType.icon}</span>
                  <span style={{color:ctType.color,fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.05em"}}>{ctType.label}</span>
                  <span style={{color:"rgba(255,255,255,0.3)",fontSize:12}}>— {block.title}</span>
                </div>
                <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,padding:"16px",fontSize:13,color:"rgba(255,255,255,0.75)",lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:block.type==="code"?"monospace":"inherit"}}>
                  {block.body}
                </div>
              </div>;
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Utils ────────────────────────────────────────────────────────────────────
function inputStyle(extra={}){
  return {width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid var(--color-border-secondary)",
    background:"var(--color-background-primary)",color:"var(--color-text-primary)",fontSize:14,
    boxSizing:"border-box",outline:"none",marginBottom:12,...extra};
}
function darkInput(extra={}){
  return {width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid rgba(255,255,255,0.1)",
    background:"rgba(255,255,255,0.06)",color:"#fff",fontSize:14,boxSizing:"border-box",outline:"none",...extra};
}
function primaryBtn(bg,color,extra={}){
  return {padding:"9px 18px",borderRadius:10,border:"none",background:bg,color,fontSize:14,fontWeight:600,cursor:"pointer",...extra};
}
function ghostBtn(extra={}){
  return {padding:"9px 14px",borderRadius:10,border:"1px solid var(--color-border-secondary)",background:"transparent",
    color:"var(--color-text-secondary)",fontSize:14,cursor:"pointer",...extra};
}